export const DEMO_DATA = {
  info: {
    nome: "Marco",
    cognome: "Ferrari",
    ruolo: "Senior Product Designer",
    email: "marco@email.com",
    telefono: "+39 333 111 0000",
    citta: "Milano",
    linkedin: "linkedin.com/in/marco",
    sommario:
      "Designer con 6 anni di esperienza in prodotti digitali B2B. Specializzato in design systems e UX research.",
    foto: null,
  },
  esperienze: [
    {
      id: 1,
      azienda: "Google Italia",
      ruolo: "Senior UX Designer",
      periodo: "2022–oggi",
      descrizione: "Lead designer su 3 prodotti SaaS, +40% retention.",
    },
    {
      id: 2,
      azienda: "Accenture",
      ruolo: "UX Designer",
      periodo: "2019–2022",
      descrizione: "Design enterprise per Fortune 500.",
    },
  ],
  formazione: [
    {
      id: 1,
      istituto: "Politecnico di Milano",
      titolo: "LM Design della Comunicazione",
      anno: "2019",
      voto: "110/110",
    },
  ],
  competenze: [
    "Figma",
    "User Research",
    "Design System",
    "React",
    "Inglese C2",
    "Sketch",
    "Prototyping",
  ],
};

export const renderCV = (
  tpl,
  info,
  esperienze,
  formazione,
  competenze,
  ai,
  preview = false,
) => {
  const D = preview ? DEMO_DATA : { info, esperienze, formazione, competenze };
  const I = D.info;
  const E = D.esperienze || [];
  const F = D.formazione || [];
  const SK = D.competenze || [];
  const acc = tpl.color;

  /* ── BASE WRAPPER ── */
  const CVBase = ({ children, style = {} }) => (
    <div
      style={{
        width: 600,
        height: 800,
        borderRadius: 16,
        overflow: "hidden",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
        fontFamily: "sans-serif",
        fontSize: 13,
        color: "#111",
        ...style,
      }}
    >
      {children}
    </div>
  );

  /* ── AVATAR ── mostra foto se presente, altrimenti iniziali */
  const Avatar = ({
    size = 64,
    radius = "50%",
    border = "",
    bg = acc,
    textColor = "#fff",
    style = {},
  }) => {
    if (I.foto) {
      return (
        <img
          src={I.foto}
          alt="Foto profilo"
          style={{
            width: size,
            height: size,
            borderRadius: radius,
            objectFit: "cover",
            flexShrink: 0,
            border: border || `2px solid ${acc}`,
            display: "block",
            ...style,
          }}
        />
      );
    }
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          background: bg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: size * 0.35,
          fontWeight: 900,
          color: textColor,
          flexShrink: 0,
          border: border,
          ...style,
        }}
      >
        {I.nome?.[0]}
        {I.cognome?.[0]}
      </div>
    );
  };

  /* ═══════════════════════════════════════════
     1. DARK NEON
  ═══════════════════════════════════════════ */
  if (tpl.style === "dark_neon") {
    return (
      <CVBase
        style={{
          background: "#0b0f0d",
          color: "#d1fae5",
          fontFamily: "'DM Mono', monospace",
        }}
      >
        <div
          style={{ padding: "24px 28px", borderBottom: `1px solid ${acc}33` }}
        >
          <div
            style={{
              color: acc,
              fontSize: 11,
              letterSpacing: 2,
              marginBottom: 8,
            }}
          >
            $ whoami
          </div>
          <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
            <Avatar
              size={52}
              radius="10px"
              border={`2px solid ${acc}`}
              bg="#111"
            />
            <div>
              <div style={{ fontSize: 20, fontWeight: 800 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ color: acc, marginBottom: 2, fontSize: 12 }}>
                {I.ruolo}
              </div>
              <div style={{ fontSize: 11, opacity: 0.5 }}>
                {I.email} · {I.telefono}
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 0, flex: 1 }}>
          <div
            style={{
              width: 140,
              background: "#060a07",
              padding: 20,
              borderRight: `1px solid ${acc}22`,
            }}
          >
            <div
              style={{
                color: acc,
                fontSize: 10,
                letterSpacing: 2,
                marginBottom: 10,
              }}
            >
              SKILLS
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  marginBottom: 6,
                  color: "#d1fae5",
                  display: "flex",
                  gap: 6,
                }}
              >
                <span style={{ color: acc }}>›</span> {s}
              </div>
            ))}
            <div
              style={{
                color: acc,
                fontSize: 10,
                letterSpacing: 2,
                marginTop: 20,
                marginBottom: 10,
              }}
            >
              STUDI
            </div>
            {F.map((f, i) => (
              <div
                key={i}
                style={{ fontSize: 10, opacity: 0.7, marginBottom: 4 }}
              >
                {f.istituto}
                <br />
                <span style={{ color: acc }}>{f.anno}</span>
              </div>
            ))}
          </div>
          <div style={{ flex: 1, padding: 20, overflowY: "hidden" }}>
            <div
              style={{
                color: acc,
                fontSize: 10,
                letterSpacing: 2,
                marginBottom: 12,
              }}
            >
              // EXPERIENCE
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 16,
                  paddingLeft: 10,
                  borderLeft: `2px solid ${acc}44`,
                }}
              >
                <div style={{ color: acc, fontSize: 11 }}>{e.periodo}</div>
                <div style={{ fontWeight: 700, marginBottom: 2 }}>
                  {e.ruolo}
                </div>
                <div style={{ opacity: 0.6, fontSize: 11 }}>{e.azienda}</div>
                <div style={{ fontSize: 11, opacity: 0.8, marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     2. MONO CLEAN
  ═══════════════════════════════════════════ */
  if (tpl.style === "mono_clean") {
    return (
      <CVBase style={{ fontFamily: "'DM Mono', monospace" }}>
        <div
          style={{
            padding: "28px 36px 20px",
            borderBottom: "2px solid #111",
            display: "flex",
            gap: 18,
            alignItems: "center",
          }}
        >
          <Avatar size={60} radius="8px" border="2px solid #111" bg="#333" />
          <div>
            <div style={{ fontSize: 24, fontWeight: 800, letterSpacing: -1 }}>
              {I.nome} {I.cognome}
            </div>
            <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
              {I.ruolo} · {I.email} · {I.telefono}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", flex: 1 }}>
          <div style={{ flex: 2, padding: "20px 36px" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#999",
                marginBottom: 10,
                borderBottom: "1px solid #eee",
                paddingBottom: 4,
              }}
            >
              ESPERIENZE
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{ display: "flex", gap: 14, marginBottom: 14 }}
              >
                <div
                  style={{
                    fontSize: 10,
                    color: "#999",
                    width: 70,
                    flexShrink: 0,
                  }}
                >
                  {e.periodo}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 12 }}>{e.ruolo}</div>
                  <div style={{ fontSize: 11, color: "#555" }}>{e.azienda}</div>
                  <div style={{ fontSize: 11, color: "#777", marginTop: 2 }}>
                    {e.descrizione}
                  </div>
                </div>
              </div>
            ))}
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#999",
                margin: "16px 0 10px",
                borderBottom: "1px solid #eee",
                paddingBottom: 4,
              }}
            >
              FORMAZIONE
            </div>
            {F.map((f, i) => (
              <div
                key={i}
                style={{ display: "flex", gap: 14, marginBottom: 8 }}
              >
                <div
                  style={{
                    fontSize: 10,
                    color: "#999",
                    width: 70,
                    flexShrink: 0,
                  }}
                >
                  {f.anno}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 12 }}>
                    {f.titolo}
                  </div>
                  <div style={{ fontSize: 11, color: "#555" }}>
                    {f.istituto}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              width: 150,
              padding: "20px 20px 20px 0",
              borderLeft: "1px solid #eee",
            }}
          >
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#999",
                marginBottom: 10,
                paddingBottom: 4,
                borderBottom: "1px solid #eee",
              }}
            >
              SKILLS
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  padding: "3px 0",
                  borderBottom: "1px solid #f5f5f5",
                  color: "#333",
                }}
              >
                {s}
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     3. TECH SPLIT
  ═══════════════════════════════════════════ */
  if (tpl.style === "tech_split") {
    return (
      <CVBase style={{ flexDirection: "row" }}>
        <div
          style={{
            width: 190,
            background: "#0f172a",
            color: "#e2e8f0",
            padding: 24,
            display: "flex",
            flexDirection: "column",
            gap: 0,
          }}
        >
          <Avatar
            size={56}
            radius="12px"
            border={`2px solid ${acc}`}
            bg={acc}
            textColor="#000"
            style={{ marginBottom: 14 }}
          />
          <div style={{ fontWeight: 800, fontSize: 15, lineHeight: 1.2 }}>
            {I.nome}
            <br />
            {I.cognome}
          </div>
          <div
            style={{ color: acc, fontSize: 11, marginTop: 4, marginBottom: 20 }}
          >
            {I.ruolo}
          </div>
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              color: "#64748b",
              marginBottom: 8,
            }}
          >
            CONTATTI
          </div>
          {[I.email, I.telefono, I.citta].filter(Boolean).map((v, i) => (
            <div
              key={i}
              style={{
                fontSize: 10,
                color: "#94a3b8",
                marginBottom: 4,
                wordBreak: "break-all",
              }}
            >
              {v}
            </div>
          ))}
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              color: "#64748b",
              marginTop: 18,
              marginBottom: 8,
            }}
          >
            SKILLS
          </div>
          {SK.map((s, i) => (
            <div key={i} style={{ marginBottom: 5 }}>
              <div style={{ fontSize: 10, color: "#cbd5e1", marginBottom: 2 }}>
                {s}
              </div>
              <div
                style={{ height: 3, background: "#1e293b", borderRadius: 2 }}
              >
                <div
                  style={{
                    width: `${55 + ((i * 13) % 45)}%`,
                    height: 3,
                    background: acc,
                    borderRadius: 2,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <div style={{ flex: 1, padding: 24, overflowY: "hidden" }}>
          <div
            style={{
              fontSize: 10,
              letterSpacing: 3,
              color: "#94a3b8",
              marginBottom: 12,
              borderBottom: `2px solid ${acc}`,
              paddingBottom: 6,
            }}
          >
            ESPERIENZE
          </div>
          {E.map((e) => (
            <div key={e.id} style={{ marginBottom: 16 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 12 }}>{e.ruolo}</div>
                <div style={{ fontSize: 10, color: acc, fontWeight: 600 }}>
                  {e.periodo}
                </div>
              </div>
              <div style={{ fontSize: 11, color: "#555", marginBottom: 3 }}>
                {e.azienda}
              </div>
              <div style={{ fontSize: 11, color: "#777" }}>{e.descrizione}</div>
            </div>
          ))}
          <div
            style={{
              fontSize: 10,
              letterSpacing: 3,
              color: "#94a3b8",
              margin: "16px 0 12px",
              borderBottom: `2px solid ${acc}`,
              paddingBottom: 6,
            }}
          >
            FORMAZIONE
          </div>
          {F.map((f, i) => (
            <div key={i} style={{ marginBottom: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
              <div style={{ fontSize: 11, color: "#555" }}>
                {f.istituto} · {f.anno}
              </div>
              {f.voto && (
                <div style={{ fontSize: 10, color: acc, fontWeight: 600 }}>
                  {f.voto}
                </div>
              )}
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     4. COLOR BLOCKS
  ═══════════════════════════════════════════ */
  if (tpl.style === "color_blocks") {
    return (
      <CVBase style={{ background: "#f8f7f4" }}>
        <div style={{ background: acc, padding: "24px 32px", color: "#fff" }}>
          <div
            style={{
              display: "flex",
              gap: 16,
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <Avatar
              size={58}
              radius="50%"
              border="2px solid rgba(255,255,255,0.5)"
              bg="rgba(0,0,0,0.25)"
              textColor="#fff"
            />
            <div>
              <div style={{ fontSize: 26, fontWeight: 900, letterSpacing: -1 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ fontSize: 13, opacity: 0.85, marginTop: 2 }}>
                {I.ruolo}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            {SK.slice(0, 5).map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 10,
                  background: "rgba(0,0,0,0.25)",
                  padding: "3px 10px",
                  borderRadius: 100,
                }}
              >
                {s}
              </span>
            ))}
          </div>
        </div>
        <div style={{ display: "flex", flex: 1 }}>
          <div style={{ flex: 3, padding: "20px 24px" }}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 800,
                color: acc,
                letterSpacing: 2,
                marginBottom: 12,
              }}
            >
              ESPERIENZE
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{ display: "flex", gap: 0, marginBottom: 14 }}
              >
                <div
                  style={{
                    width: 4,
                    background: acc,
                    borderRadius: 2,
                    marginRight: 12,
                    flexShrink: 0,
                  }}
                />
                <div>
                  <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                  <div style={{ fontSize: 11, color: "#666" }}>
                    {e.azienda} · {e.periodo}
                  </div>
                  <div style={{ fontSize: 11, color: "#888", marginTop: 3 }}>
                    {e.descrizione}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              width: 160,
              background: "#fff",
              padding: 20,
              borderLeft: `3px solid ${acc}22`,
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 800,
                color: acc,
                letterSpacing: 2,
                marginBottom: 12,
              }}
            >
              STUDI
            </div>
            {F.map((f, i) => (
              <div key={i} style={{ marginBottom: 14 }}>
                <div style={{ fontWeight: 700, fontSize: 12 }}>
                  {f.istituto}
                </div>
                <div style={{ fontSize: 11, color: "#666" }}>{f.titolo}</div>
                <div style={{ fontSize: 10, color: acc }}>{f.anno}</div>
              </div>
            ))}
            <div
              style={{
                fontSize: 11,
                fontWeight: 800,
                color: acc,
                letterSpacing: 2,
                margin: "16px 0 12px",
              }}
            >
              TOOLS
            </div>
            {SK.slice(5).map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  padding: "4px 8px",
                  background: `${acc}15`,
                  borderRadius: 6,
                  marginBottom: 4,
                  color: "#333",
                }}
              >
                {s}
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     5. ILLUSTRATION
  ═══════════════════════════════════════════ */
  if (tpl.style === "illustration") {
    return (
      <CVBase style={{ background: "#fffbf5" }}>
        <div
          style={{
            padding: "28px 32px 20px",
            display: "flex",
            gap: 20,
            alignItems: "center",
          }}
        >
          <Avatar
            size={70}
            radius="50%"
            border={`2px solid ${acc}66`}
            bg={`linear-gradient(135deg, ${acc}, ${acc}88)`}
            textColor="#fff"
          />
          <div>
            <div style={{ fontSize: 24, fontWeight: 900 }}>
              {I.nome} {I.cognome}
            </div>
            <div style={{ color: acc, fontWeight: 600 }}>{I.ruolo}</div>
            <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
              {I.email} · {I.telefono}
            </div>
          </div>
        </div>
        <div
          style={{
            padding: "0 32px 12px",
            display: "flex",
            gap: 6,
            flexWrap: "wrap",
          }}
        >
          {SK.map((s, i) => (
            <span
              key={i}
              style={{
                fontSize: 10,
                padding: "4px 10px",
                background:
                  i % 3 === 0
                    ? `${acc}20`
                    : i % 3 === 1
                      ? "#f3f4f6"
                      : "#fff9ec",
                borderRadius: 100,
                color: i % 3 === 0 ? acc : "#555",
                border: `1px solid ${i % 3 === 0 ? acc + "44" : "#e5e7eb"}`,
              }}
            >
              {s}
            </span>
          ))}
        </div>
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 12,
            padding: "0 32px 24px",
          }}
        >
          {E.map((e) => (
            <div
              key={e.id}
              style={{
                background: "#fff",
                border: "1px solid #f0e8d8",
                borderRadius: 12,
                padding: 14,
                borderTop: `3px solid ${acc}`,
              }}
            >
              <div
                style={{
                  fontSize: 10,
                  color: acc,
                  fontWeight: 700,
                  marginBottom: 4,
                }}
              >
                {e.periodo}
              </div>
              <div style={{ fontWeight: 700, fontSize: 13 }}>{e.ruolo}</div>
              <div style={{ fontSize: 11, color: "#777" }}>{e.azienda}</div>
              <div style={{ fontSize: 11, color: "#888", marginTop: 6 }}>
                {e.descrizione}
              </div>
            </div>
          ))}
          {F.map((f, i) => (
            <div
              key={i}
              style={{
                background: `${acc}10`,
                border: `1px solid ${acc}30`,
                borderRadius: 12,
                padding: 14,
              }}
            >
              <div
                style={{
                  fontSize: 10,
                  color: acc,
                  fontWeight: 700,
                  marginBottom: 4,
                }}
              >
                {f.anno}
              </div>
              <div style={{ fontWeight: 700, fontSize: 13 }}>{f.titolo}</div>
              <div style={{ fontSize: 11, color: "#777" }}>{f.istituto}</div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     6. POSTER
  ═══════════════════════════════════════════ */
  if (tpl.style === "poster") {
    return (
      <CVBase
        style={{ background: "#0d0d0d", color: "#fff", fontFamily: "serif" }}
      >
        <div
          style={{
            flex: 1,
            padding: "32px 36px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 20,
              alignItems: "flex-start",
              marginBottom: 20,
            }}
          >
            <Avatar
              size={64}
              radius="8px"
              border={`2px solid ${acc}`}
              bg="#111"
              textColor={acc}
            />
            <div>
              <div
                style={{
                  fontSize: 11,
                  letterSpacing: 6,
                  color: acc,
                  textTransform: "uppercase",
                  marginBottom: 8,
                }}
              >
                {I.ruolo}
              </div>
              <div
                style={{
                  fontSize: 42,
                  fontWeight: 900,
                  lineHeight: 0.9,
                  letterSpacing: -2,
                }}
              >
                {I.nome}
                <br />
                <span style={{ color: acc }}>{I.cognome}</span>
              </div>
            </div>
          </div>
          <div
            style={{ height: 2, background: acc, marginBottom: 24, width: 80 }}
          />
          {E.map((e) => (
            <div
              key={e.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 10,
                fontSize: 13,
                borderBottom: "1px solid #222",
                paddingBottom: 10,
              }}
            >
              <div>
                <span style={{ fontWeight: 700 }}>{e.ruolo}</span>
                <span style={{ color: "#888", marginLeft: 8 }}>
                  — {e.azienda}
                </span>
              </div>
              <span style={{ color: acc, fontSize: 11 }}>{e.periodo}</span>
            </div>
          ))}
          <div style={{ marginTop: "auto" }}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 6,
                marginBottom: 16,
              }}
            >
              {SK.map((s, i) => (
                <span
                  key={i}
                  style={{
                    fontSize: 10,
                    padding: "4px 12px",
                    border: `1px solid ${i % 2 === 0 ? acc : "#333"}`,
                    borderRadius: 100,
                    color: i % 2 === 0 ? acc : "#888",
                  }}
                >
                  {s}
                </span>
              ))}
            </div>
            <div style={{ fontSize: 11, color: "#555" }}>
              {I.email} · {I.telefono}
            </div>
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     7. KPI DASHBOARD
  ═══════════════════════════════════════════ */
  if (tpl.style === "kpi_dashboard") {
    return (
      <CVBase style={{ background: "#0f172a", color: "#f1f5f9" }}>
        <div
          style={{
            padding: "20px 28px 16px",
            borderBottom: "1px solid #1e293b",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 14,
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <Avatar
              size={48}
              radius="10px"
              border={`2px solid ${acc}`}
              bg="#1e293b"
              textColor={acc}
            />
            <div>
              <div style={{ fontSize: 20, fontWeight: 800 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ color: acc, marginTop: 1, fontSize: 12 }}>
                {I.ruolo}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            {["+120%", "3.5M€", "CTR 8%", "3 brand"].map((k, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  background: "#1e293b",
                  padding: "10px 8px",
                  borderRadius: 10,
                  textAlign: "center",
                }}
              >
                <div style={{ color: acc, fontWeight: 800, fontSize: 14 }}>
                  {k}
                </div>
                <div style={{ fontSize: 9, opacity: 0.5, marginTop: 2 }}>
                  KPI
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ flex: 1, display: "flex" }}>
          <div style={{ flex: 2, padding: "16px 20px" }}>
            <div
              style={{
                fontSize: 9,
                letterSpacing: 2,
                color: "#64748b",
                marginBottom: 10,
              }}
            >
              ESPERIENZE
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 12,
                  padding: 12,
                  background: "#1e293b",
                  borderRadius: 10,
                  borderLeft: `3px solid ${acc}`,
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 12 }}>{e.ruolo}</div>
                <div style={{ fontSize: 10, color: acc }}>
                  {e.azienda} · {e.periodo}
                </div>
                <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
          </div>
          <div style={{ width: 160, padding: "16px 16px 16px 0" }}>
            <div
              style={{
                fontSize: 9,
                letterSpacing: 2,
                color: "#64748b",
                marginBottom: 10,
              }}
            >
              TOOLS
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  padding: "5px 8px",
                  marginBottom: 4,
                  background: "#1e293b",
                  borderRadius: 6,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <div
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: acc,
                    flexShrink: 0,
                  }}
                />
                {s}
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     8. GRADIENT MODERN
  ═══════════════════════════════════════════ */
  if (tpl.style === "gradient_modern") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            background: `linear-gradient(135deg, #7c3aed, #ec4899)`,
            padding: "28px 32px 40px",
            color: "#fff",
            position: "relative",
          }}
        >
          <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
            <Avatar
              size={60}
              radius="50%"
              border="2px solid rgba(255,255,255,0.6)"
              bg="rgba(0,0,0,0.2)"
              textColor="#fff"
            />
            <div>
              <div style={{ fontSize: 24, fontWeight: 900, letterSpacing: -1 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ opacity: 0.85, marginTop: 2 }}>{I.ruolo}</div>
              <div style={{ fontSize: 11, opacity: 0.65, marginTop: 4 }}>
                {I.email} · {I.telefono}
              </div>
            </div>
          </div>
          <div
            style={{ display: "flex", gap: 6, marginTop: 14, flexWrap: "wrap" }}
          >
            {SK.slice(0, 4).map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 10,
                  padding: "3px 10px",
                  background: "rgba(255,255,255,0.2)",
                  borderRadius: 100,
                }}
              >
                {s}
              </span>
            ))}
          </div>
        </div>
        <div style={{ flex: 1, padding: "0 32px 24px", marginTop: -12 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 8,
              marginBottom: 16,
            }}
          >
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  padding: 14,
                  boxShadow: "0 2px 12px rgba(124,58,237,0.12)",
                  border: "1px solid #f3e8ff",
                }}
              >
                <div
                  style={{ fontSize: 10, color: "#7c3aed", fontWeight: 700 }}
                >
                  {e.periodo}
                </div>
                <div style={{ fontWeight: 700, fontSize: 12, margin: "2px 0" }}>
                  {e.ruolo}
                </div>
                <div style={{ fontSize: 11, color: "#888" }}>{e.azienda}</div>
              </div>
            ))}
          </div>
          <div style={{ background: "#fdf4ff", borderRadius: 12, padding: 14 }}>
            {F.map((f, i) => (
              <div key={i} style={{ fontSize: 12 }}>
                <span style={{ fontWeight: 700 }}>{f.titolo}</span>
                <span style={{ color: "#888", marginLeft: 6 }}>
                  — {f.istituto}, {f.anno}
                </span>
              </div>
            ))}
          </div>
          <div
            style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 12 }}
          >
            {SK.map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 10,
                  padding: "4px 10px",
                  background: i % 2 === 0 ? "#f3e8ff" : "#fce7f3",
                  color: i % 2 === 0 ? "#7c3aed" : "#ec4899",
                  borderRadius: 100,
                }}
              >
                {s}
              </span>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     9. MARKETING SPLIT
  ═══════════════════════════════════════════ */
  if (tpl.style === "marketing_split") {
    return (
      <CVBase style={{ flexDirection: "row" }}>
        <div
          style={{
            width: 200,
            background: acc,
            color: "#fff",
            padding: 24,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Avatar
            size={56}
            radius="50%"
            border="2px solid rgba(255,255,255,0.5)"
            bg="rgba(0,0,0,0.25)"
            textColor="#fff"
            style={{ marginBottom: 14 }}
          />
          <div
            style={{
              fontSize: 18,
              fontWeight: 900,
              lineHeight: 1.1,
              marginBottom: 4,
            }}
          >
            {I.nome}
            <br />
            {I.cognome}
          </div>
          <div
            style={{
              fontSize: 11,
              opacity: 0.8,
              marginBottom: 24,
              paddingBottom: 16,
              borderBottom: "1px solid rgba(255,255,255,0.3)",
            }}
          >
            {I.ruolo}
          </div>
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              opacity: 0.7,
              marginBottom: 8,
            }}
          >
            CONTATTI
          </div>
          <div style={{ fontSize: 10, opacity: 0.85, lineHeight: 1.8 }}>
            {I.email}
            <br />
            {I.telefono}
            <br />
            {I.citta}
          </div>
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              opacity: 0.7,
              marginTop: 20,
              marginBottom: 8,
            }}
          >
            COMPETENZE
          </div>
          {SK.map((s, i) => (
            <div
              key={i}
              style={{
                fontSize: 10,
                opacity: 0.9,
                padding: "3px 0",
                borderBottom: "1px solid rgba(255,255,255,0.15)",
              }}
            >
              {s}
            </div>
          ))}
          <div style={{ marginTop: "auto", fontSize: 10, opacity: 0.6 }}>
            linkedin.com/in/marco
          </div>
        </div>
        <div style={{ flex: 1, padding: 24 }}>
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              color: acc,
              fontWeight: 700,
              marginBottom: 10,
              borderBottom: `2px solid ${acc}`,
              paddingBottom: 6,
            }}
          >
            ESPERIENZE
          </div>
          {E.map((e) => (
            <div key={e.id} style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                <div style={{ fontSize: 10, color: acc }}>{e.periodo}</div>
              </div>
              <div style={{ fontSize: 11, color: "#666" }}>{e.azienda}</div>
              <div style={{ fontSize: 11, color: "#888", marginTop: 3 }}>
                {e.descrizione}
              </div>
            </div>
          ))}
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              color: acc,
              fontWeight: 700,
              margin: "14px 0 10px",
              borderBottom: `2px solid ${acc}`,
              paddingBottom: 6,
            }}
          >
            FORMAZIONE
          </div>
          {F.map((f, i) => (
            <div key={i}>
              <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
              <div style={{ fontSize: 11, color: "#666" }}>
                {f.istituto} · {f.anno}
              </div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     10. APP UI
  ═══════════════════════════════════════════ */
  if (tpl.style === "app_ui") {
    return (
      <CVBase style={{ background: "#f9fafb" }}>
        <div
          style={{
            background: "#fff",
            padding: "20px 24px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            alignItems: "center",
            gap: 16,
          }}
        >
          <Avatar
            size={48}
            radius="14px"
            border="none"
            bg={acc}
            textColor="#fff"
          />
          <div>
            <div style={{ fontWeight: 700, fontSize: 16 }}>
              {I.nome} {I.cognome}
            </div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>{I.ruolo}</div>
          </div>
          <div
            style={{
              marginLeft: "auto",
              fontSize: 11,
              color: "#9ca3af",
              textAlign: "right",
            }}
          >
            {I.email}
            <br />
            {I.telefono}
          </div>
        </div>
        <div style={{ padding: "16px 20px", overflowY: "hidden" }}>
          <div
            style={{
              display: "flex",
              gap: 8,
              marginBottom: 16,
              overflowX: "hidden",
              flexWrap: "wrap",
            }}
          >
            {SK.slice(0, 6).map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 11,
                  padding: "5px 12px",
                  background: i === 0 ? acc : "#fff",
                  color: i === 0 ? "#fff" : "#374151",
                  border: `1px solid ${i === 0 ? acc : "#e5e7eb"}`,
                  borderRadius: 8,
                  fontWeight: i === 0 ? 700 : 400,
                }}
              >
                {s}
              </span>
            ))}
          </div>
          {E.map((e) => (
            <div
              key={e.id}
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 12,
                padding: 14,
                marginBottom: 8,
                display: "flex",
                gap: 12,
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background: `${acc}20`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 14,
                  flexShrink: 0,
                }}
              >
                🏢
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 12 }}>
                  {e.ruolo}{" "}
                  <span style={{ color: "#9ca3af", fontWeight: 400 }}>
                    @ {e.azienda}
                  </span>
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>
                  {e.descrizione}
                </div>
              </div>
              <div
                style={{
                  marginLeft: "auto",
                  fontSize: 10,
                  color: acc,
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
              >
                {e.periodo}
              </div>
            </div>
          ))}
          {F.map((f, i) => (
            <div
              key={i}
              style={{
                background: `${acc}10`,
                border: `1px solid ${acc}25`,
                borderRadius: 12,
                padding: 14,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {f.istituto}
                </div>
              </div>
              <div style={{ fontSize: 11, color: acc, fontWeight: 700 }}>
                {f.voto || f.anno}
              </div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     11. ROADMAP
  ═══════════════════════════════════════════ */
  if (tpl.style === "roadmap") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            padding: "24px 32px 20px",
            borderBottom: `3px solid ${acc}`,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 16,
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <Avatar
              size={54}
              radius="50%"
              border={`2px solid ${acc}`}
              bg={acc}
              textColor="#fff"
            />
            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <div
                    style={{ fontSize: 22, fontWeight: 900, letterSpacing: -1 }}
                  >
                    {I.nome} {I.cognome}
                  </div>
                  <div style={{ color: acc, fontWeight: 600 }}>{I.ruolo}</div>
                </div>
                <div
                  style={{ textAlign: "right", fontSize: 11, color: "#888" }}
                >
                  {I.email}
                  <br />
                  {I.telefono}
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 6 }}>
            {SK.slice(0, 5).map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 10,
                  padding: "3px 10px",
                  background: `${acc}15`,
                  color: acc,
                  borderRadius: 100,
                  fontWeight: 600,
                }}
              >
                {s}
              </span>
            ))}
          </div>
        </div>
        <div style={{ flex: 1, padding: "20px 32px", position: "relative" }}>
          <div
            style={{
              position: "absolute",
              left: 54,
              top: 20,
              bottom: 20,
              width: 2,
              background: `${acc}22`,
            }}
          />
          {[
            ...E,
            ...F.map((f) => ({
              ...f,
              ruolo: f.titolo,
              azienda: f.istituto,
              periodo: f.anno,
              descrizione: f.voto || "",
            })),
          ].map((item, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                gap: 16,
                marginBottom: 18,
                position: "relative",
              }}
            >
              <div
                style={{
                  width: 50,
                  textAlign: "right",
                  fontSize: 10,
                  color: acc,
                  fontWeight: 700,
                  paddingTop: 2,
                  flexShrink: 0,
                }}
              >
                {item.periodo || item.anno}
              </div>
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: acc,
                  border: `2px solid #fff`,
                  boxShadow: `0 0 0 2px ${acc}`,
                  marginTop: 3,
                  flexShrink: 0,
                  zIndex: 1,
                }}
              />
              <div>
                <div style={{ fontWeight: 700 }}>{item.ruolo}</div>
                <div style={{ fontSize: 11, color: "#666" }}>
                  {item.azienda}
                </div>
                {item.descrizione && (
                  <div style={{ fontSize: 11, color: "#888", marginTop: 3 }}>
                    {item.descrizione}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     12. BOLD MINIMAL
  ═══════════════════════════════════════════ */
  if (tpl.style === "bold_minimal") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div style={{ padding: "32px 40px 24px" }}>
          <div style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
            <Avatar
              size={72}
              radius="12px"
              border={`3px solid ${acc}`}
              bg={acc}
              textColor="#fff"
            />
            <div>
              <div
                style={{
                  fontSize: 38,
                  fontWeight: 900,
                  lineHeight: 0.9,
                  letterSpacing: -2,
                  color: "#0a0a0a",
                }}
              >
                {I.nome}
                <br />
                {I.cognome}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginTop: 10,
                }}
              >
                <div
                  style={{
                    height: 4,
                    width: 40,
                    background: acc,
                    borderRadius: 2,
                  }}
                />
                <div style={{ fontSize: 13, fontWeight: 700, color: acc }}>
                  {I.ruolo}
                </div>
              </div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
                {I.email} · {I.telefono}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 0,
          }}
        >
          <div
            style={{ padding: "0 0 0 40px", borderRight: "1px solid #f1f5f9" }}
          >
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: acc,
                fontWeight: 700,
                marginBottom: 14,
              }}
            >
              ESPERIENZE
            </div>
            {E.map((e) => (
              <div key={e.id} style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 13, fontWeight: 800 }}>{e.ruolo}</div>
                <div style={{ fontSize: 11, color: acc }}>{e.azienda}</div>
                <div style={{ fontSize: 10, color: "#9ca3af" }}>
                  {e.periodo}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
          </div>
          <div style={{ padding: "0 40px" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: acc,
                fontWeight: 700,
                marginBottom: 14,
              }}
            >
              SKILLS
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "6px 0",
                  borderBottom: "1px solid #f9fafb",
                }}
              >
                <span style={{ fontSize: 12, fontWeight: 600 }}>{s}</span>
                <span style={{ fontSize: 9, color: acc }}>
                  ●●●{i % 3 === 0 ? "●" : "○"}
                </span>
              </div>
            ))}
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: acc,
                fontWeight: 700,
                margin: "16px 0 10px",
              }}
            >
              STUDI
            </div>
            {F.map((f, i) => (
              <div key={i}>
                <div style={{ fontSize: 12, fontWeight: 700 }}>{f.titolo}</div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {f.istituto} · {f.anno}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     13. CORPORATE
  ═══════════════════════════════════════════ */
  if (tpl.style === "corporate") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            background: acc,
            padding: "20px 32px",
            color: "#fff",
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={54}
            radius="8px"
            border="2px solid rgba(255,255,255,0.4)"
            bg="rgba(0,0,0,0.2)"
            textColor="#fff"
          />
          <div>
            <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: -0.5 }}>
              {I.nome} {I.cognome}
            </div>
            <div
              style={{
                fontSize: 12,
                opacity: 0.85,
                marginTop: 2,
                letterSpacing: 1,
              }}
            >
              {I.ruolo.toUpperCase()}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            borderBottom: "1px solid #e5e7eb",
            padding: "10px 32px",
            gap: 24,
            fontSize: 11,
            color: "#6b7280",
          }}
        >
          <span>{I.email}</span>
          <span>·</span>
          <span>{I.telefono}</span>
          <span>·</span>
          <span>{I.citta}</span>
        </div>
        <div style={{ flex: 1, display: "flex" }}>
          <div style={{ flex: 2, padding: "20px 32px" }}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: acc,
                letterSpacing: 2,
                borderBottom: `2px solid ${acc}`,
                paddingBottom: 6,
                marginBottom: 14,
              }}
            >
              ESPERIENZE PROFESSIONALI
            </div>
            {E.map((e) => (
              <div key={e.id} style={{ marginBottom: 16 }}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                  <div style={{ fontSize: 11, color: "#9ca3af" }}>
                    {e.periodo}
                  </div>
                </div>
                <div style={{ fontSize: 12, color: acc, fontWeight: 600 }}>
                  {e.azienda}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: acc,
                letterSpacing: 2,
                borderBottom: `2px solid ${acc}`,
                paddingBottom: 6,
                margin: "14px 0",
              }}
            >
              FORMAZIONE
            </div>
            {F.map((f, i) => (
              <div
                key={i}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <div style={{ fontWeight: 700 }}>{f.titolo}</div>
                  <div style={{ fontSize: 11, color: "#6b7280" }}>
                    {f.istituto}
                  </div>
                </div>
                <div style={{ fontSize: 11, color: "#9ca3af" }}>{f.anno}</div>
              </div>
            ))}
          </div>
          <div
            style={{
              width: 160,
              background: "#f8fafc",
              padding: "20px 16px",
              borderLeft: "1px solid #e5e7eb",
            }}
          >
            <div
              style={{
                fontSize: 10,
                fontWeight: 700,
                color: acc,
                letterSpacing: 2,
                marginBottom: 12,
              }}
            >
              COMPETENZE
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  padding: "5px 0",
                  borderBottom: "1px solid #e5e7eb",
                  color: "#374151",
                }}
              >
                {s}
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     14. SERIF
  ═══════════════════════════════════════════ */
  if (tpl.style === "serif") {
    return (
      <CVBase style={{ fontFamily: "Georgia, serif", background: "#faf9f7" }}>
        <div
          style={{
            textAlign: "center",
            padding: "32px 40px 20px",
            borderBottom: "2px solid #111",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 14,
            }}
          >
            <Avatar
              size={72}
              radius="50%"
              border="2px solid #111"
              bg="#333"
              textColor="#fff"
            />
          </div>
          <div style={{ fontSize: 30, fontWeight: 700, letterSpacing: -1 }}>
            {I.nome} {I.cognome}
          </div>
          <div
            style={{
              fontSize: 12,
              color: "#555",
              marginTop: 6,
              letterSpacing: 2,
              fontFamily: "sans-serif",
              textTransform: "uppercase",
            }}
          >
            {I.ruolo}
          </div>
          <div
            style={{
              fontSize: 11,
              color: "#999",
              marginTop: 6,
              fontFamily: "sans-serif",
            }}
          >
            {I.email} · {I.telefono} · {I.citta}
          </div>
        </div>
        <div style={{ flex: 1, padding: "16px 40px" }}>
          {I.sommario && (
            <div
              style={{
                fontSize: 13,
                lineHeight: 1.8,
                color: "#444",
                marginBottom: 16,
                fontStyle: "italic",
                borderBottom: "1px solid #ddd",
                paddingBottom: 14,
              }}
            >
              {I.sommario}
            </div>
          )}
          <div
            style={{
              fontSize: 11,
              fontFamily: "sans-serif",
              fontWeight: 700,
              letterSpacing: 3,
              color: "#999",
              marginBottom: 10,
            }}
          >
            ESPERIENZE
          </div>
          {E.map((e) => (
            <div
              key={e.id}
              style={{ display: "flex", gap: 16, marginBottom: 14 }}
            >
              <div
                style={{
                  width: 80,
                  fontSize: 11,
                  color: "#999",
                  fontFamily: "sans-serif",
                  flexShrink: 0,
                }}
              >
                {e.periodo}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700 }}>
                  {e.ruolo},{" "}
                  <span style={{ fontStyle: "italic", fontWeight: 400 }}>
                    {e.azienda}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            </div>
          ))}
          <div
            style={{
              fontSize: 11,
              fontFamily: "sans-serif",
              fontWeight: 700,
              letterSpacing: 3,
              color: "#999",
              margin: "14px 0 10px",
            }}
          >
            FORMAZIONE
          </div>
          {F.map((f, i) => (
            <div key={i} style={{ display: "flex", gap: 16 }}>
              <div
                style={{
                  width: 80,
                  fontSize: 11,
                  color: "#999",
                  fontFamily: "sans-serif",
                }}
              >
                {f.anno}
              </div>
              <div>
                <div style={{ fontWeight: 700 }}>{f.titolo}</div>
                <div
                  style={{ fontStyle: "italic", fontSize: 12, color: "#666" }}
                >
                  {f.istituto}
                </div>
              </div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     15. EXECUTIVE
  ═══════════════════════════════════════════ */
  if (tpl.style === "executive") {
    return (
      <CVBase style={{ flexDirection: "row", fontFamily: "Georgia, serif" }}>
        <div
          style={{
            width: 210,
            background: "#1f2937",
            color: "#f9fafb",
            padding: 28,
          }}
        >
          <Avatar
            size={64}
            radius="50%"
            border={`2px solid ${acc}`}
            bg="#374151"
            textColor={acc}
            style={{ marginBottom: 14 }}
          />
          <div
            style={{
              fontSize: 20,
              fontWeight: 700,
              lineHeight: 1.1,
              marginBottom: 6,
            }}
          >
            {I.nome}
            <br />
            {I.cognome}
          </div>
          <div
            style={{ height: 2, background: acc, margin: "12px 0", width: 40 }}
          />
          <div
            style={{
              fontSize: 11,
              color: "#9ca3af",
              fontFamily: "sans-serif",
              marginBottom: 20,
            }}
          >
            {I.ruolo}
          </div>
          <div
            style={{
              fontSize: 9,
              letterSpacing: 2,
              color: "#6b7280",
              fontFamily: "sans-serif",
              marginBottom: 8,
            }}
          >
            CONTATTI
          </div>
          <div
            style={{
              fontSize: 10,
              color: "#d1d5db",
              fontFamily: "sans-serif",
              lineHeight: 2,
            }}
          >
            {I.email}
            <br />
            {I.telefono}
            <br />
            {I.citta}
          </div>
          <div
            style={{
              fontSize: 9,
              letterSpacing: 2,
              color: "#6b7280",
              fontFamily: "sans-serif",
              marginTop: 20,
              marginBottom: 8,
            }}
          >
            COMPETENZE
          </div>
          {SK.map((s, i) => (
            <div
              key={i}
              style={{
                fontSize: 10,
                color: "#d1d5db",
                fontFamily: "sans-serif",
                padding: "3px 0",
                borderBottom: "1px solid #374151",
              }}
            >
              {s}
            </div>
          ))}
          <div
            style={{
              fontSize: 9,
              letterSpacing: 2,
              color: "#6b7280",
              fontFamily: "sans-serif",
              marginTop: 20,
              marginBottom: 8,
            }}
          >
            FORMAZIONE
          </div>
          {F.map((f, i) => (
            <div key={i} style={{ marginBottom: 8 }}>
              <div
                style={{
                  fontSize: 11,
                  fontFamily: "sans-serif",
                  fontStyle: "italic",
                  color: "#e5e7eb",
                }}
              >
                {f.titolo}
              </div>
              <div
                style={{
                  fontSize: 10,
                  color: "#9ca3af",
                  fontFamily: "sans-serif",
                }}
              >
                {f.istituto} · {f.anno}
              </div>
            </div>
          ))}
        </div>
        <div style={{ flex: 1, padding: 28 }}>
          <div style={{ height: 3, background: acc, marginBottom: 20 }} />
          <div
            style={{
              fontSize: 9,
              fontFamily: "sans-serif",
              letterSpacing: 3,
              color: "#9ca3af",
              marginBottom: 14,
            }}
          >
            PERCORSO PROFESSIONALE
          </div>
          {E.map((e) => (
            <div
              key={e.id}
              style={{
                marginBottom: 18,
                paddingBottom: 16,
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 14 }}>{e.ruolo}</div>
                <div
                  style={{ fontSize: 10, fontFamily: "sans-serif", color: acc }}
                >
                  {e.periodo}
                </div>
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: "#6b7280",
                  fontFamily: "sans-serif",
                  marginBottom: 4,
                }}
              >
                {e.azienda}
              </div>
              <div style={{ fontSize: 12, lineHeight: 1.6, color: "#374151" }}>
                {e.descrizione}
              </div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     16. LATEX
  ═══════════════════════════════════════════ */
  if (tpl.style === "latex") {
    return (
      <CVBase
        style={{
          fontFamily: "'Computer Modern', Georgia, serif",
          background: "#fff",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "28px 40px 16px",
            borderBottom: "1px solid #000",
          }}
        >
          {I.foto && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 12,
              }}
            >
              <Avatar
                size={60}
                radius="50%"
                border="1px solid #000"
                bg="#333"
                textColor="#fff"
              />
            </div>
          )}
          <div style={{ fontSize: 26, fontWeight: 700 }}>
            {I.nome} {I.cognome}
          </div>
          <div style={{ fontSize: 12, marginTop: 8, color: "#333" }}>
            {I.email} | {I.telefono} | {I.citta}
          </div>
        </div>
        <div style={{ flex: 1, padding: "16px 40px" }}>
          {[
            {
              label: "ESPERIENZE",
              items: E.map((e) => ({
                titolo: `${e.ruolo}, \\textit{${e.azienda}}`,
                sub: e.periodo,
                desc: e.descrizione,
              })),
            },
            {
              label: "FORMAZIONE",
              items: F.map((f) => ({
                titolo: `${f.titolo}`,
                sub: `${f.istituto}, ${f.anno}${f.voto ? " — " + f.voto : ""}`,
                desc: "",
              })),
            },
          ].map((section) => (
            <div key={section.label} style={{ marginBottom: 16 }}>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 13,
                  borderBottom: "1px solid #000",
                  marginBottom: 8,
                  paddingBottom: 2,
                  letterSpacing: 0.5,
                }}
              >
                {section.label}
              </div>
              {section.items.map((item, i) => (
                <div
                  key={i}
                  style={{ display: "flex", gap: 14, marginBottom: 10 }}
                >
                  <div
                    style={{
                      width: 80,
                      fontSize: 11,
                      color: "#555",
                      flexShrink: 0,
                      lineHeight: 1.5,
                    }}
                  >
                    {item.sub}
                  </div>
                  <div>
                    <div
                      style={{ fontSize: 13 }}
                      dangerouslySetInnerHTML={{
                        __html: item.titolo.replace(
                          /\\textit\{(.+?)\}/,
                          "<em>$1</em>",
                        ),
                      }}
                    />
                    {item.desc && (
                      <div
                        style={{ fontSize: 11, color: "#555", marginTop: 3 }}
                      >
                        {item.desc}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ))}
          <div
            style={{
              fontWeight: 700,
              fontSize: 13,
              borderBottom: "1px solid #000",
              marginBottom: 8,
              paddingBottom: 2,
            }}
          >
            COMPETENZE
          </div>
          <div style={{ fontSize: 12, lineHeight: 1.6 }}>{SK.join(" · ")}</div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     17. ACADEMIC TIMELINE
  ═══════════════════════════════════════════ */
  if (tpl.style === "academic_timeline") {
    return (
      <CVBase style={{ background: "#faf9f7" }}>
        <div
          style={{
            background: acc,
            padding: "20px 32px",
            color: "#fff",
            display: "flex",
            gap: 14,
            alignItems: "center",
          }}
        >
          <Avatar
            size={52}
            radius="50%"
            border="2px solid rgba(255,255,255,0.5)"
            bg="rgba(0,0,0,0.2)"
            textColor="#fff"
          />
          <div>
            <div style={{ fontSize: 20, fontWeight: 800 }}>
              {I.nome} {I.cognome}
            </div>
            <div style={{ opacity: 0.85, marginTop: 2, fontSize: 12 }}>
              {I.ruolo}
            </div>
            <div style={{ fontSize: 11, opacity: 0.65, marginTop: 4 }}>
              {I.email} · {I.telefono}
            </div>
          </div>
        </div>
        <div style={{ flex: 1, display: "flex" }}>
          <div
            style={{
              flex: 1,
              padding: "20px 24px",
              borderRight: "1px solid #e5e7eb",
            }}
          >
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: acc,
                fontWeight: 700,
                marginBottom: 14,
              }}
            >
              RICERCA & CARRIERA
            </div>
            {[
              ...E,
              ...F.map((f) => ({
                ...f,
                ruolo: f.titolo,
                azienda: f.istituto,
                periodo: f.anno,
              })),
            ].map((item, i) => (
              <div
                key={i}
                style={{ display: "flex", gap: 10, marginBottom: 14 }}
              >
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: acc,
                    marginTop: 4,
                    flexShrink: 0,
                  }}
                />
                <div>
                  <div style={{ fontSize: 10, color: acc, fontWeight: 600 }}>
                    {item.periodo || item.anno}
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 12 }}>
                    {item.ruolo}
                  </div>
                  <div style={{ fontSize: 11, color: "#666" }}>
                    {item.azienda}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ width: 170, padding: "20px 20px 20px 16px" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: acc,
                fontWeight: 700,
                marginBottom: 14,
              }}
            >
              COMPETENZE
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  padding: "5px 0",
                  borderBottom: "1px solid #f0ede8",
                  color: "#374151",
                }}
              >
                {s}
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     18. ACADEMIC COLUMNS
  ═══════════════════════════════════════════ */
  if (tpl.style === "academic_columns") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            padding: "24px 32px 16px",
            borderBottom: `3px double ${acc}`,
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={56}
            radius="50%"
            border={`2px solid ${acc}`}
            bg={acc}
            textColor="#fff"
          />
          <div>
            <div
              style={{
                fontSize: 24,
                fontWeight: 700,
                fontFamily: "Georgia, serif",
              }}
            >
              {I.nome} {I.cognome}
            </div>
            <div
              style={{
                display: "flex",
                gap: 12,
                marginTop: 4,
                fontSize: 11,
                color: "#666",
              }}
            >
              <span>{I.email}</span>
              <span>·</span>
              <span>{I.telefono}</span>
              <span>·</span>
              <span>{I.ruolo}</span>
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 0,
          }}
        >
          <div
            style={{
              padding: "16px 20px 16px 32px",
              borderRight: `1px solid ${acc}33`,
            }}
          >
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: acc,
                fontWeight: 700,
                marginBottom: 12,
                fontFamily: "Georgia, serif",
              }}
            >
              POSIZIONI ACCADEMICHE
            </div>
            {E.map((e) => (
              <div key={e.id} style={{ marginBottom: 14 }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 12,
                    fontFamily: "Georgia, serif",
                  }}
                >
                  {e.ruolo}
                </div>
                <div style={{ fontSize: 11, color: "#555" }}>{e.azienda}</div>
                <div style={{ fontSize: 10, color: acc }}>{e.periodo}</div>
                <div style={{ fontSize: 11, color: "#777", marginTop: 3 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: acc,
                fontWeight: 700,
                margin: "14px 0 12px",
                fontFamily: "Georgia, serif",
              }}
            >
              FORMAZIONE
            </div>
            {F.map((f, i) => (
              <div key={i} style={{ marginBottom: 10 }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 12,
                    fontFamily: "Georgia, serif",
                  }}
                >
                  {f.titolo}
                </div>
                <div style={{ fontSize: 11, color: "#555" }}>
                  {f.istituto}, {f.anno}
                </div>
                {f.voto && (
                  <div style={{ fontSize: 10, color: acc }}>{f.voto}</div>
                )}
              </div>
            ))}
          </div>
          <div style={{ padding: "16px 32px 16px 20px" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: acc,
                fontWeight: 700,
                marginBottom: 12,
              }}
            >
              COMPETENZE & LINGUE
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "4px 0",
                  borderBottom: "1px solid #f5f5f5",
                }}
              >
                <div
                  style={{
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    background: acc,
                  }}
                />
                <span style={{ fontSize: 11 }}>{s}</span>
              </div>
            ))}
            {I.sommario && (
              <div
                style={{
                  marginTop: 16,
                  padding: 12,
                  background: `${acc}08`,
                  borderLeft: `2px solid ${acc}`,
                  borderRadius: "0 6px 6px 0",
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    letterSpacing: 2,
                    color: acc,
                    fontWeight: 700,
                    marginBottom: 6,
                  }}
                >
                  PROFILO
                </div>
                <div
                  style={{
                    fontSize: 11,
                    lineHeight: 1.6,
                    color: "#555",
                    fontFamily: "Georgia, serif",
                    fontStyle: "italic",
                  }}
                >
                  {I.sommario}
                </div>
              </div>
            )}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     19-21. PA / CIVIC
  ═══════════════════════════════════════════ */
  if (
    tpl.style === "neutral" ||
    tpl.style === "civic_split" ||
    tpl.style === "formal_doc"
  ) {
    const isSplit = tpl.style === "civic_split";
    const isFormal = tpl.style === "formal_doc";
    return (
      <CVBase style={{ background: isFormal ? "#fff" : "#f9fafb" }}>
        {isFormal ? (
          <div
            style={{
              padding: "20px 40px",
              borderBottom: "2px solid #111",
              display: "flex",
              gap: 16,
              alignItems: "center",
            }}
          >
            <Avatar
              size={52}
              radius="6px"
              border="1px solid #111"
              bg="#333"
              textColor="#fff"
            />
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontSize: 20, fontWeight: 700 }}>
                  {I.nome} {I.cognome}
                </div>
                <div style={{ fontSize: 12, color: "#555", marginTop: 2 }}>
                  {I.ruolo}
                </div>
              </div>
              <div style={{ textAlign: "right", fontSize: 11, color: "#666" }}>
                {I.email}
                <br />
                {I.telefono}
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              background: "#374151",
              padding: "20px 32px",
              color: "#fff",
              display: "flex",
              gap: 14,
              alignItems: "center",
            }}
          >
            <Avatar
              size={48}
              radius="50%"
              border="2px solid rgba(255,255,255,0.3)"
              bg="rgba(255,255,255,0.1)"
              textColor="#fff"
            />
            <div>
              <div style={{ fontSize: 18, fontWeight: 700 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2 }}>
                {I.ruolo} · {I.email}
              </div>
            </div>
          </div>
        )}
        <div
          style={{
            flex: 1,
            display: isSplit ? "flex" : "block",
            padding: isSplit ? 0 : "20px 40px",
          }}
        >
          {isSplit ? (
            <>
              <div style={{ width: 180, background: "#e5e7eb", padding: 20 }}>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: 700,
                    letterSpacing: 2,
                    color: "#6b7280",
                    marginBottom: 12,
                  }}
                >
                  COMPETENZE
                </div>
                {SK.map((s, i) => (
                  <div
                    key={i}
                    style={{
                      fontSize: 11,
                      padding: "4px 0",
                      borderBottom: "1px solid #d1d5db",
                      color: "#374151",
                    }}
                  >
                    {s}
                  </div>
                ))}
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: 700,
                    letterSpacing: 2,
                    color: "#6b7280",
                    marginTop: 16,
                    marginBottom: 12,
                  }}
                >
                  FORMAZIONE
                </div>
                {F.map((f, i) => (
                  <div key={i} style={{ marginBottom: 8 }}>
                    <div style={{ fontWeight: 700, fontSize: 11 }}>
                      {f.titolo}
                    </div>
                    <div style={{ fontSize: 10, color: "#6b7280" }}>
                      {f.istituto} · {f.anno}
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ flex: 1, padding: 20 }}>
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: 700,
                    letterSpacing: 2,
                    color: "#6b7280",
                    marginBottom: 12,
                  }}
                >
                  ESPERIENZE
                </div>
                {E.map((e) => (
                  <div
                    key={e.id}
                    style={{
                      marginBottom: 14,
                      paddingBottom: 14,
                      borderBottom: "1px solid #e5e7eb",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                      <div style={{ fontSize: 10, color: "#9ca3af" }}>
                        {e.periodo}
                      </div>
                    </div>
                    <div style={{ fontSize: 11, color: "#6b7280" }}>
                      {e.azienda}
                    </div>
                    <div
                      style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}
                    >
                      {e.descrizione}
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  letterSpacing: 2,
                  color: "#6b7280",
                  marginBottom: 12,
                }}
              >
                ESPERIENZE
              </div>
              {E.map((e) => (
                <div
                  key={e.id}
                  style={{ display: "flex", gap: 16, marginBottom: 12 }}
                >
                  <div
                    style={{
                      width: 80,
                      fontSize: 11,
                      color: "#9ca3af",
                      flexShrink: 0,
                    }}
                  >
                    {e.periodo}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700 }}>
                      {e.ruolo} — {e.azienda}
                    </div>
                    <div
                      style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}
                    >
                      {e.descrizione}
                    </div>
                  </div>
                </div>
              ))}
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  letterSpacing: 2,
                  color: "#6b7280",
                  margin: "16px 0 12px",
                }}
              >
                FORMAZIONE
              </div>
              {F.map((f, i) => (
                <div
                  key={i}
                  style={{ display: "flex", gap: 16, marginBottom: 8 }}
                >
                  <div style={{ width: 80, fontSize: 11, color: "#9ca3af" }}>
                    {f.anno}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700 }}>{f.titolo}</div>
                    <div style={{ fontSize: 11, color: "#6b7280" }}>
                      {f.istituto}
                    </div>
                  </div>
                </div>
              ))}
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  letterSpacing: 2,
                  color: "#6b7280",
                  margin: "16px 0 12px",
                }}
              >
                COMPETENZE
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {SK.map((s, i) => (
                  <span
                    key={i}
                    style={{
                      fontSize: 11,
                      padding: "3px 10px",
                      border: "1px solid #d1d5db",
                      borderRadius: 6,
                      color: "#374151",
                    }}
                  >
                    {s}
                  </span>
                ))}
              </div>
            </>
          )}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     22-24. HEALTH
  ═══════════════════════════════════════════ */
  if (
    tpl.style === "medical_clean" ||
    tpl.style === "medical_split" ||
    tpl.style === "wellness"
  ) {
    if (tpl.style === "wellness") {
      return (
        <CVBase style={{ background: "#f0fdf4" }}>
          <div
            style={{
              background: `linear-gradient(135deg, #10b981, #84cc16)`,
              padding: "24px 32px",
              color: "#fff",
              display: "flex",
              gap: 16,
              alignItems: "center",
            }}
          >
            <Avatar
              size={56}
              radius="50%"
              border="2px solid rgba(255,255,255,0.6)"
              bg="rgba(0,0,0,0.15)"
              textColor="#fff"
            />
            <div>
              <div style={{ fontSize: 22, fontWeight: 900 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ opacity: 0.9, marginTop: 2 }}>{I.ruolo}</div>
            </div>
          </div>
          <div
            style={{
              padding: "0 32px 8px",
              display: "flex",
              gap: 6,
              flexWrap: "wrap",
              marginTop: 12,
            }}
          >
            {SK.slice(0, 4).map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 10,
                  padding: "3px 10px",
                  background: "rgba(16,185,129,0.1)",
                  borderRadius: 100,
                  color: "#10b981",
                  border: "1px solid rgba(16,185,129,0.3)",
                }}
              >
                {s}
              </span>
            ))}
          </div>
          <div
            style={{
              flex: 1,
              padding: "8px 28px 24px",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 10,
            }}
          >
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  padding: 14,
                  border: "1px solid #d1fae5",
                }}
              >
                <div
                  style={{ fontSize: 10, color: "#10b981", fontWeight: 700 }}
                >
                  {e.periodo}
                </div>
                <div style={{ fontWeight: 700, fontSize: 12 }}>{e.ruolo}</div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {e.azienda}
                </div>
                <div style={{ fontSize: 11, color: "#888", marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
            {F.map((f, i) => (
              <div
                key={i}
                style={{
                  background: "#ecfdf5",
                  borderRadius: 12,
                  padding: 14,
                  border: "1px solid #a7f3d0",
                }}
              >
                <div
                  style={{ fontSize: 10, color: "#10b981", fontWeight: 700 }}
                >
                  Formazione
                </div>
                <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {f.istituto} · {f.anno}
                </div>
              </div>
            ))}
          </div>
        </CVBase>
      );
    }
    return (
      <CVBase
        style={{
          flexDirection: tpl.style === "medical_split" ? "row" : "column",
        }}
      >
        {tpl.style === "medical_split" ? (
          <>
            <div
              style={{
                width: 190,
                background: "#f0fdf4",
                borderRight: `3px solid ${acc}`,
                padding: 24,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Avatar
                size={56}
                radius="50%"
                border={`2px solid ${acc}`}
                bg={acc}
                textColor="#fff"
                style={{ marginBottom: 14 }}
              />
              <div style={{ fontWeight: 800, fontSize: 14 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ fontSize: 11, color: acc, marginBottom: 16 }}>
                {I.ruolo}
              </div>
              <div
                style={{
                  fontSize: 10,
                  letterSpacing: 2,
                  color: "#6b7280",
                  marginBottom: 8,
                }}
              >
                CONTATTI
              </div>
              <div style={{ fontSize: 10, color: "#374151", lineHeight: 1.8 }}>
                {I.email}
                <br />
                {I.telefono}
              </div>
              <div
                style={{
                  fontSize: 10,
                  letterSpacing: 2,
                  color: "#6b7280",
                  marginTop: 16,
                  marginBottom: 8,
                }}
              >
                COMPETENZE
              </div>
              {SK.map((s, i) => (
                <div
                  key={i}
                  style={{
                    fontSize: 10,
                    padding: "3px 0",
                    borderBottom: "1px solid #d1fae5",
                    color: "#374151",
                  }}
                >
                  {s}
                </div>
              ))}
            </div>
            <div style={{ flex: 1, padding: 24 }}>
              <div
                style={{
                  fontSize: 10,
                  letterSpacing: 2,
                  color: acc,
                  fontWeight: 700,
                  marginBottom: 12,
                }}
              >
                ESPERIENZE
              </div>
              {E.map((e) => (
                <div
                  key={e.id}
                  style={{
                    marginBottom: 14,
                    paddingBottom: 12,
                    borderBottom: "1px solid #f0fdf4",
                  }}
                >
                  <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                  <div style={{ fontSize: 11, color: acc }}>
                    {e.azienda} · {e.periodo}
                  </div>
                  <div style={{ fontSize: 11, color: "#6b7280", marginTop: 3 }}>
                    {e.descrizione}
                  </div>
                </div>
              ))}
              <div
                style={{
                  fontSize: 10,
                  letterSpacing: 2,
                  color: acc,
                  fontWeight: 700,
                  margin: "12px 0 10px",
                }}
              >
                FORMAZIONE
              </div>
              {F.map((f, i) => (
                <div key={i}>
                  <div style={{ fontWeight: 700 }}>{f.titolo}</div>
                  <div style={{ fontSize: 11, color: "#6b7280" }}>
                    {f.istituto} · {f.anno}
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                background: acc,
                padding: "20px 32px",
                color: "#fff",
                display: "flex",
                gap: 14,
                alignItems: "center",
              }}
            >
              <Avatar
                size={52}
                radius="50%"
                border="2px solid rgba(255,255,255,0.5)"
                bg="rgba(0,0,0,0.15)"
                textColor="#fff"
              />
              <div>
                <div style={{ fontSize: 20, fontWeight: 800 }}>
                  {I.nome} {I.cognome}
                </div>
                <div style={{ opacity: 0.9, marginTop: 2, fontSize: 12 }}>
                  {I.ruolo}
                </div>
                <div style={{ fontSize: 11, opacity: 0.7, marginTop: 2 }}>
                  {I.email} · {I.telefono}
                </div>
              </div>
            </div>
            <div style={{ flex: 1, display: "flex" }}>
              <div style={{ flex: 2, padding: "20px 28px" }}>
                <div
                  style={{
                    fontSize: 10,
                    letterSpacing: 2,
                    color: acc,
                    fontWeight: 700,
                    marginBottom: 12,
                  }}
                >
                  ESPERIENZE
                </div>
                {E.map((e) => (
                  <div
                    key={e.id}
                    style={{
                      marginBottom: 14,
                      borderLeft: `3px solid ${acc}30`,
                      paddingLeft: 12,
                    }}
                  >
                    <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                    <div style={{ fontSize: 11, color: acc }}>
                      {e.azienda} · {e.periodo}
                    </div>
                    <div
                      style={{ fontSize: 11, color: "#6b7280", marginTop: 3 }}
                    >
                      {e.descrizione}
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ width: 160, padding: "20px 20px 20px 0" }}>
                <div
                  style={{
                    fontSize: 10,
                    letterSpacing: 2,
                    color: acc,
                    fontWeight: 700,
                    marginBottom: 12,
                  }}
                >
                  SKILLS
                </div>
                {SK.map((s, i) => (
                  <div
                    key={i}
                    style={{
                      fontSize: 11,
                      padding: "4px 8px",
                      background: `${acc}12`,
                      borderRadius: 6,
                      marginBottom: 4,
                      color: "#374151",
                    }}
                  >
                    {s}
                  </div>
                ))}
                <div
                  style={{
                    fontSize: 10,
                    letterSpacing: 2,
                    color: acc,
                    fontWeight: 700,
                    margin: "16px 0 10px",
                  }}
                >
                  STUDI
                </div>
                {F.map((f, i) => (
                  <div key={i} style={{ marginBottom: 8 }}>
                    <div style={{ fontWeight: 700, fontSize: 11 }}>
                      {f.titolo}
                    </div>
                    <div style={{ fontSize: 10, color: "#6b7280" }}>
                      {f.istituto}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     25. ENGINEERING GRID
  ═══════════════════════════════════════════ */
  if (tpl.style === "engineering_grid") {
    return (
      <CVBase style={{ background: "#f8fafc" }}>
        <div
          style={{
            background: "#0c4a6e",
            padding: "20px 32px",
            color: "#fff",
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={52}
            radius="10px"
            border={`2px solid ${acc}`}
            bg="#0369a1"
            textColor={acc}
          />
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <div>
              <div
                style={{ fontSize: 20, fontWeight: 800, letterSpacing: -0.5 }}
              >
                {I.nome} {I.cognome}
              </div>
              <div style={{ color: acc, marginTop: 2, fontSize: 12 }}>
                {I.ruolo}
              </div>
            </div>
            <div style={{ textAlign: "right", fontSize: 10, opacity: 0.7 }}>
              {I.email}
              <br />
              {I.telefono}
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "2fr 1fr",
            gap: 0,
          }}
        >
          <div
            style={{ padding: "16px 24px", borderRight: `2px solid ${acc}30` }}
          >
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: "#0369a1",
                fontWeight: 700,
                marginBottom: 12,
              }}
            >
              ESPERIENZE
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 14,
                  background: "#fff",
                  padding: 12,
                  borderRadius: 8,
                  borderLeft: `3px solid ${acc}`,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ fontWeight: 700, fontSize: 12 }}>{e.ruolo}</div>
                  <div style={{ fontSize: 10, color: acc }}>{e.periodo}</div>
                </div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {e.azienda}
                </div>
                <div style={{ fontSize: 11, color: "#888", marginTop: 3 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: "#0369a1",
                fontWeight: 700,
                margin: "12px 0 10px",
              }}
            >
              FORMAZIONE
            </div>
            {F.map((f, i) => (
              <div
                key={i}
                style={{ background: "#fff", padding: 12, borderRadius: 8 }}
              >
                <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {f.istituto} · {f.anno}
                </div>
              </div>
            ))}
          </div>
          <div style={{ padding: "16px 16px 16px 16px" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: "#0369a1",
                fontWeight: 700,
                marginBottom: 12,
              }}
            >
              SKILLS
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 4,
              }}
            >
              {SK.map((s, i) => (
                <div
                  key={i}
                  style={{
                    fontSize: 10,
                    padding: "5px 6px",
                    background: `${acc}15`,
                    border: `1px solid ${acc}30`,
                    borderRadius: 4,
                    textAlign: "center",
                    color: "#0c4a6e",
                    fontWeight: 600,
                  }}
                >
                  {s}
                </div>
              ))}
            </div>
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     26. BLUEPRINT
  ═══════════════════════════════════════════ */
  if (tpl.style === "blueprint") {
    return (
      <CVBase
        style={{
          background: "#0369a1",
          color: "#e0f2fe",
          fontFamily: "monospace",
        }}
      >
        <div
          style={{
            padding: "20px 32px",
            borderBottom: "1px dashed #0ea5e9",
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={52}
            radius="8px"
            border={`2px dashed ${acc}`}
            bg="#0284c7"
            textColor="#38bdf8"
          />
          <div>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 4,
                color: "#38bdf8",
                marginBottom: 4,
              }}
            >
              CURRICULUM VITAE // REV.1
            </div>
            <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -1 }}>
              {I.nome} {I.cognome}
            </div>
            <div style={{ color: "#7dd3fc", fontSize: 12 }}>{I.ruolo}</div>
          </div>
        </div>
        <div style={{ flex: 1, display: "flex" }}>
          <div style={{ flex: 2, padding: "16px 28px" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#38bdf8",
                marginBottom: 10,
              }}
            >
              [ EXPERIENCE ]
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 14,
                  padding: "8px 12px",
                  border: "1px dashed #1e40af",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ fontWeight: 700, fontSize: 12 }}>{e.ruolo}</div>
                  <div style={{ fontSize: 10, color: "#38bdf8" }}>
                    {e.periodo}
                  </div>
                </div>
                <div style={{ fontSize: 11, color: "#7dd3fc" }}>
                  {e.azienda}
                </div>
                <div style={{ fontSize: 11, opacity: 0.7, marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
          </div>
          <div style={{ width: 170, padding: "16px 20px 16px 0" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#38bdf8",
                marginBottom: 10,
              }}
            >
              [ SPECS ]
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 10,
                  padding: "4px 0",
                  borderBottom: "1px dashed #1e40af",
                  color: "#bae6fd",
                }}
              >
                ▸ {s}
              </div>
            ))}
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#38bdf8",
                marginTop: 16,
                marginBottom: 10,
              }}
            >
              [ EDU ]
            </div>
            {F.map((f, i) => (
              <div key={i} style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 11, fontWeight: 700 }}>
                  {f.istituto}
                </div>
                <div style={{ fontSize: 10, color: "#7dd3fc" }}>{f.anno}</div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     27. PROCESS FLOW
  ═══════════════════════════════════════════ */
  if (tpl.style === "process_flow") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            background: `linear-gradient(135deg, #0ea5e9, #0369a1)`,
            padding: "20px 32px",
            color: "#fff",
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={52}
            radius="50%"
            border="2px solid rgba(255,255,255,0.5)"
            bg="rgba(0,0,0,0.2)"
            textColor="#fff"
          />
          <div>
            <div style={{ fontSize: 20, fontWeight: 800 }}>
              {I.nome} {I.cognome}
            </div>
            <div style={{ opacity: 0.85, marginTop: 2, fontSize: 12 }}>
              {I.ruolo}
            </div>
            <div style={{ fontSize: 11, opacity: 0.65, marginTop: 2 }}>
              {I.email} · {I.telefono}
            </div>
          </div>
        </div>
        <div style={{ flex: 1, padding: "16px 28px" }}>
          <div
            style={{
              display: "flex",
              gap: 6,
              marginBottom: 14,
              flexWrap: "wrap",
            }}
          >
            {SK.map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 10,
                  padding: "4px 10px",
                  background: `${acc}15`,
                  border: `1px solid ${acc}40`,
                  borderRadius: 4,
                  color: "#0369a1",
                  fontWeight: 600,
                }}
              >
                {s}
              </span>
            ))}
          </div>
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              color: "#0369a1",
              fontWeight: 700,
              marginBottom: 12,
            }}
          >
            FLUSSO CARRIERA
          </div>
          {E.map((e, i) => (
            <div
              key={e.id}
              style={{ display: "flex", gap: 12, marginBottom: 0 }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: 28,
                    height: 28,
                    borderRadius: "50%",
                    background: acc,
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 12,
                    fontWeight: 800,
                    flexShrink: 0,
                  }}
                >
                  {i + 1}
                </div>
                {i < E.length - 1 && (
                  <div
                    style={{
                      width: 2,
                      flex: 1,
                      background: `${acc}30`,
                      minHeight: 16,
                    }}
                  />
                )}
              </div>
              <div style={{ paddingBottom: 14 }}>
                <div style={{ fontWeight: 700, fontSize: 12 }}>{e.ruolo}</div>
                <div style={{ fontSize: 11, color: acc }}>
                  {e.azienda} · {e.periodo}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 3 }}>
                  {e.descrizione}
                </div>
              </div>
            </div>
          ))}
          {F.map((f, i) => (
            <div
              key={i}
              style={{
                marginTop: 8,
                padding: 10,
                background: "#f0f9ff",
                borderRadius: 8,
                borderLeft: `3px solid ${acc}`,
              }}
            >
              <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
              <div style={{ fontSize: 11, color: "#6b7280" }}>
                {f.istituto} · {f.anno}
              </div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     28. PORTFOLIO
  ═══════════════════════════════════════════ */
  if (tpl.style === "portfolio") {
    return (
      <CVBase style={{ background: "#0a0a0a", color: "#e5e7eb" }}>
        <div
          style={{
            padding: "24px 32px 16px",
            borderBottom: "1px solid #222",
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={52}
            radius="8px"
            border={`2px solid ${acc}`}
            bg="#111"
            textColor={acc}
          />
          <div>
            <div
              style={{
                fontSize: 26,
                fontWeight: 900,
                letterSpacing: -1,
                color: "#fff",
              }}
            >
              {I.nome} {I.cognome}
            </div>
            <div style={{ color: "#9ca3af", marginTop: 2, fontSize: 12 }}>
              {I.ruolo}
            </div>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 1,
            background: "#222",
          }}
        >
          {E.map((e) => (
            <div key={e.id} style={{ background: "#0a0a0a", padding: 20 }}>
              <div
                style={{
                  fontSize: 10,
                  color: acc,
                  fontWeight: 700,
                  marginBottom: 4,
                }}
              >
                {e.periodo}
              </div>
              <div style={{ fontWeight: 700, color: "#fff" }}>{e.ruolo}</div>
              <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 6 }}>
                {e.azienda}
              </div>
              <div style={{ fontSize: 11, color: "#9ca3af" }}>
                {e.descrizione}
              </div>
            </div>
          ))}
          <div style={{ background: "#0a0a0a", padding: 20 }}>
            <div
              style={{
                fontSize: 10,
                color: acc,
                fontWeight: 700,
                marginBottom: 8,
              }}
            >
              STRUMENTI
            </div>
            {SK.slice(0, 5).map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  color: "#9ca3af",
                  padding: "3px 0",
                  borderBottom: "1px solid #1a1a1a",
                }}
              >
                {s}
              </div>
            ))}
          </div>
          <div style={{ background: "#111", padding: 20 }}>
            {F.map((f, i) => (
              <div key={i}>
                <div
                  style={{
                    fontSize: 10,
                    color: acc,
                    fontWeight: 700,
                    marginBottom: 4,
                  }}
                >
                  STUDI
                </div>
                <div style={{ fontWeight: 700, color: "#fff", fontSize: 12 }}>
                  {f.titolo}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {f.istituto}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     29. MONOCHROME
  ═══════════════════════════════════════════ */
  if (tpl.style === "monochrome") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            padding: "36px 44px 24px",
            display: "flex",
            gap: 24,
            alignItems: "flex-start",
          }}
        >
          <Avatar
            size={80}
            radius="4px"
            border="2px solid #111"
            bg="#111"
            textColor="#fff"
          />
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: 34,
                fontWeight: 900,
                letterSpacing: -2,
                lineHeight: 0.9,
                color: "#111",
              }}
            >
              {I.nome}
              <br />
              {I.cognome}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 14,
              }}
            >
              <div style={{ height: 1, width: 30, background: "#111" }} />
              <div
                style={{
                  fontSize: 11,
                  color: "#111",
                  letterSpacing: 3,
                  textTransform: "uppercase",
                }}
              >
                {I.ruolo}
              </div>
              <div style={{ height: 1, flex: 1, background: "#111" }} />
            </div>
            <div style={{ fontSize: 11, color: "#999", marginTop: 6 }}>
              {I.email} · {I.telefono}
            </div>
          </div>
        </div>
        <div
          style={{ flex: 1, display: "flex", padding: "0 44px 32px", gap: 32 }}
        >
          <div style={{ flex: 2 }}>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 18,
                  borderBottom: "1px solid #f1f5f9",
                  paddingBottom: 16,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                  <div style={{ fontSize: 10, color: "#9ca3af" }}>
                    {e.periodo}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#374151",
                    fontStyle: "italic",
                  }}
                >
                  {e.azienda}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
            {F.map((f, i) => (
              <div key={i}>
                <div style={{ fontWeight: 700 }}>{f.titolo}</div>
                <div style={{ fontSize: 12, color: "#374151" }}>
                  {f.istituto} · {f.anno}
                </div>
              </div>
            ))}
          </div>
          <div style={{ width: 130 }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: "#111",
                fontWeight: 700,
                marginBottom: 12,
              }}
            >
              SKILLS
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  padding: "4px 0",
                  borderBottom: "1px solid #f9fafb",
                  color: "#374151",
                }}
              >
                {s}
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     30. STUDIO
  ═══════════════════════════════════════════ */
  if (tpl.style === "studio") {
    return (
      <CVBase style={{ flexDirection: "row", background: "#fafaf9" }}>
        <div
          style={{
            width: 60,
            background: "#111",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "24px 0",
            gap: 20,
          }}
        >
          <div style={{ color: acc, fontSize: 18 }}>A</div>
          {["STUDIO", "SKILLS", "EDU"].map((l, i) => (
            <div
              key={i}
              style={{
                fontSize: 10,
                color: "#555",
                writingMode: "vertical-rl",
                letterSpacing: 3,
              }}
            >
              {l}
            </div>
          ))}
        </div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <div
            style={{
              padding: "20px 24px 16px",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              gap: 14,
              alignItems: "center",
            }}
          >
            <Avatar
              size={48}
              radius="50%"
              border={`2px solid ${acc}`}
              bg={acc}
              textColor="#fff"
            />
            <div>
              <div style={{ fontSize: 20, fontWeight: 900, letterSpacing: -1 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 1 }}>
                {I.ruolo} · {I.email}
              </div>
            </div>
          </div>
          <div
            style={{
              flex: 1,
              padding: "16px 24px",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12,
            }}
          >
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  padding: 12,
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 12 }}>{e.ruolo}</div>
                <div style={{ fontSize: 11, color: acc }}>{e.azienda}</div>
                <div style={{ fontSize: 10, color: "#9ca3af" }}>
                  {e.periodo}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
            <div
              style={{
                padding: 12,
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 8,
              }}
            >
              <div style={{ fontSize: 10, color: "#9ca3af", marginBottom: 6 }}>
                COMPETENZE
              </div>
              {SK.slice(0, 6).map((s, i) => (
                <div
                  key={i}
                  style={{ fontSize: 11, color: "#374151", padding: "2px 0" }}
                >
                  → {s}
                </div>
              ))}
            </div>
            {F.map((f, i) => (
              <div
                key={i}
                style={{
                  padding: 12,
                  background: `${acc}10`,
                  border: `1px solid ${acc}30`,
                  borderRadius: 8,
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {f.istituto} · {f.anno}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     31. LUXURY
  ═══════════════════════════════════════════ */
  if (tpl.style === "luxury") {
    return (
      <CVBase
        style={{
          background: "#0a0a0a",
          color: "#f5f5f5",
          fontFamily: "Georgia, serif",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "36px 40px 20px",
            borderBottom: `1px solid ${acc}44`,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 16,
            }}
          >
            <Avatar
              size={72}
              radius="50%"
              border={`2px solid ${acc}`}
              bg="#111"
              textColor={acc}
            />
          </div>
          <div
            style={{
              fontSize: 10,
              letterSpacing: 8,
              color: acc,
              marginBottom: 10,
            }}
          >
            CV
          </div>
          <div
            style={{
              fontSize: 28,
              fontWeight: 700,
              letterSpacing: 2,
              color: "#f5f5f5",
            }}
          >
            {I.nome} {I.cognome}
          </div>
          <div
            style={{
              fontSize: 11,
              color: acc,
              marginTop: 6,
              letterSpacing: 4,
              fontFamily: "sans-serif",
            }}
          >
            {I.ruolo.toUpperCase()}
          </div>
          <div
            style={{
              fontSize: 10,
              color: "#555",
              marginTop: 8,
              fontFamily: "sans-serif",
            }}
          >
            {I.email} · {I.telefono}
          </div>
        </div>
        <div
          style={{ flex: 1, display: "flex", padding: "20px 40px", gap: 32 }}
        >
          <div style={{ flex: 2 }}>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 16,
                  paddingBottom: 14,
                  borderBottom: `1px solid #1a1a1a`,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                  <div
                    style={{
                      fontSize: 10,
                      color: acc,
                      fontFamily: "sans-serif",
                    }}
                  >
                    {e.periodo}
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#9ca3af",
                    fontStyle: "italic",
                  }}
                >
                  {e.azienda}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#6b7280",
                    fontFamily: "sans-serif",
                    marginTop: 4,
                  }}
                >
                  {e.descrizione}
                </div>
              </div>
            ))}
          </div>
          <div style={{ width: 150 }}>
            <div
              style={{
                fontSize: 9,
                letterSpacing: 3,
                color: acc,
                fontFamily: "sans-serif",
                marginBottom: 10,
              }}
            >
              EXPERTISE
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  color: "#9ca3af",
                  padding: "4px 0",
                  borderBottom: `1px solid #1a1a1a`,
                  fontFamily: "sans-serif",
                }}
              >
                {s}
              </div>
            ))}
            {F.map((f, i) => (
              <div key={i} style={{ marginTop: 16 }}>
                <div
                  style={{
                    fontSize: 9,
                    letterSpacing: 3,
                    color: acc,
                    fontFamily: "sans-serif",
                    marginBottom: 6,
                  }}
                >
                  EDUCATION
                </div>
                <div style={{ fontWeight: 700, fontSize: 12 }}>
                  {f.istituto}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    color: "#6b7280",
                    fontFamily: "sans-serif",
                  }}
                >
                  {f.anno}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     32. EDITORIAL
  ═══════════════════════════════════════════ */
  if (tpl.style === "editorial") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div style={{ display: "flex", height: "100%" }}>
          <div
            style={{
              width: "45%",
              background: "#000",
              color: "#fff",
              padding: 28,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Avatar
              size={60}
              radius="50%"
              border={`2px solid ${acc}`}
              bg="#111"
              textColor={acc}
              style={{ marginBottom: 16 }}
            />
            <div
              style={{
                fontSize: 38,
                fontWeight: 900,
                lineHeight: 0.85,
                letterSpacing: -2,
                marginBottom: 16,
              }}
            >
              {I.nome.toUpperCase()}
              <br />
              <span style={{ color: acc }}>{I.cognome.toUpperCase()}</span>
            </div>
            <div
              style={{
                height: 2,
                background: acc,
                width: 60,
                marginBottom: 16,
              }}
            />
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: acc,
                marginBottom: 16,
              }}
            >
              {I.ruolo.toUpperCase()}
            </div>
            <div style={{ fontSize: 10, color: "#555", lineHeight: 2 }}>
              {I.email}
              <br />
              {I.telefono}
              <br />
              {I.citta}
            </div>
            <div style={{ marginTop: "auto" }}>
              {SK.map((s, i) => (
                <div
                  key={i}
                  style={{
                    fontSize: 10,
                    color: "#fff",
                    borderBottom: "1px solid #222",
                    padding: "4px 0",
                    letterSpacing: 1,
                  }}
                >
                  {s}
                </div>
              ))}
            </div>
          </div>
          <div style={{ flex: 1, padding: "28px 24px" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#111",
                fontWeight: 700,
                marginBottom: 16,
              }}
            >
              ESPERIENZE
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 16,
                  paddingBottom: 14,
                  borderBottom: "1px solid #f5f5f5",
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 13 }}>{e.ruolo}</div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 11,
                    color: "#888",
                    marginBottom: 4,
                  }}
                >
                  <span>{e.azienda}</span>
                  <span>{e.periodo}</span>
                </div>
                <div style={{ fontSize: 11, color: "#555" }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
            {F.map((f, i) => (
              <div
                key={i}
                style={{
                  marginTop: 8,
                  padding: 12,
                  background: "#f9fafb",
                  borderRadius: 8,
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
                <div style={{ fontSize: 11, color: "#888" }}>
                  {f.istituto} · {f.anno}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     33. ATELIER
  ═══════════════════════════════════════════ */
  if (tpl.style === "atelier") {
    return (
      <CVBase style={{ flexDirection: "row", background: "#faf8f4" }}>
        <div
          style={{
            width: 200,
            background: "#1a1209",
            color: "#f5e6c8",
            padding: 24,
          }}
        >
          <Avatar
            size={56}
            radius="50%"
            border={`2px solid ${acc}`}
            bg="#2d1f0e"
            textColor={acc}
            style={{ marginBottom: 14 }}
          />
          <div
            style={{
              fontSize: 10,
              letterSpacing: 4,
              color: acc,
              marginBottom: 10,
            }}
          >
            ATELIER
          </div>
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              lineHeight: 1.1,
              marginBottom: 4,
              fontFamily: "Georgia, serif",
            }}
          >
            {I.nome}
            <br />
            {I.cognome}
          </div>
          <div
            style={{
              fontSize: 10,
              color: acc,
              marginBottom: 20,
              letterSpacing: 2,
            }}
          >
            {I.ruolo.toUpperCase()}
          </div>
          <div style={{ height: 1, background: "#2d1f0e", marginBottom: 14 }} />
          {[I.email, I.telefono].map((v, i) => (
            <div
              key={i}
              style={{ fontSize: 10, color: "#a89060", marginBottom: 4 }}
            >
              {v}
            </div>
          ))}
          <div style={{ height: 1, background: "#2d1f0e", margin: "14px 0" }} />
          <div
            style={{
              fontSize: 9,
              letterSpacing: 2,
              color: acc,
              marginBottom: 8,
            }}
          >
            EXPERTISE
          </div>
          {SK.map((s, i) => (
            <div
              key={i}
              style={{
                fontSize: 10,
                color: "#c4a86a",
                padding: "3px 0",
                borderBottom: "1px solid #2d1f0e",
              }}
            >
              {s}
            </div>
          ))}
        </div>
        <div style={{ flex: 1, padding: 24 }}>
          <div
            style={{
              fontSize: 9,
              letterSpacing: 3,
              color: "#a89060",
              fontWeight: 700,
              marginBottom: 14,
            }}
          >
            PARCOURS
          </div>
          {E.map((e) => (
            <div
              key={e.id}
              style={{
                marginBottom: 16,
                borderBottom: "1px solid #e8dcc8",
                paddingBottom: 14,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: 700, fontFamily: "Georgia, serif" }}>
                  {e.ruolo}
                </div>
                <div style={{ fontSize: 10, color: acc }}>{e.periodo}</div>
              </div>
              <div
                style={{ fontSize: 12, color: "#a89060", fontStyle: "italic" }}
              >
                {e.azienda}
              </div>
              <div style={{ fontSize: 11, color: "#6b5a3e", marginTop: 4 }}>
                {e.descrizione}
              </div>
            </div>
          ))}
          {F.map((f, i) => (
            <div
              key={i}
              style={{ background: "#f0e8d8", padding: 12, borderRadius: 8 }}
            >
              <div
                style={{
                  fontWeight: 700,
                  fontFamily: "Georgia, serif",
                  fontSize: 12,
                }}
              >
                {f.titolo}
              </div>
              <div style={{ fontSize: 11, color: "#a89060" }}>
                {f.istituto} · {f.anno}
              </div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     34. EDITORIAL MEDIA
  ═══════════════════════════════════════════ */
  if (tpl.style === "editorial_media") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            background: "#ef4444",
            padding: "18px 32px",
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={52}
            radius="50%"
            border="2px solid rgba(255,255,255,0.5)"
            bg="rgba(0,0,0,0.2)"
            textColor="#fff"
          />
          <div>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 6,
                color: "rgba(255,255,255,0.7)",
                marginBottom: 4,
              }}
            >
              CV — {new Date().getFullYear()}
            </div>
            <div
              style={{
                fontSize: 28,
                fontWeight: 900,
                color: "#fff",
                letterSpacing: -1,
                lineHeight: 1,
              }}
            >
              {I.nome} {I.cognome}
            </div>
            <div
              style={{
                fontSize: 12,
                color: "rgba(255,255,255,0.8)",
                marginTop: 2,
              }}
            >
              {I.ruolo}
            </div>
          </div>
        </div>
        <div style={{ flex: 1, display: "flex" }}>
          <div style={{ flex: 3, padding: "20px 28px" }}>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  display: "flex",
                  gap: 14,
                  marginBottom: 14,
                  paddingBottom: 14,
                  borderBottom: "1px solid #fee2e2",
                }}
              >
                <div
                  style={{
                    width: 3,
                    background: "#ef4444",
                    borderRadius: 2,
                    flexShrink: 0,
                  }}
                />
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>{e.ruolo}</div>
                  <div style={{ fontSize: 11, color: "#ef4444" }}>
                    {e.azienda} · {e.periodo}
                  </div>
                  <div style={{ fontSize: 11, color: "#6b7280", marginTop: 3 }}>
                    {e.descrizione}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            style={{
              width: 155,
              padding: "20px 20px 20px 0",
              borderLeft: "1px solid #fee2e2",
            }}
          >
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: "#ef4444",
                fontWeight: 700,
                marginBottom: 10,
              }}
            >
              SKILLS
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  padding: "4px 0",
                  borderBottom: "1px solid #fff5f5",
                  color: "#374151",
                }}
              >
                {s}
              </div>
            ))}
            {F.map((f, i) => (
              <div key={i} style={{ marginTop: 14 }}>
                <div
                  style={{
                    fontSize: 10,
                    letterSpacing: 2,
                    color: "#ef4444",
                    fontWeight: 700,
                    marginBottom: 6,
                  }}
                >
                  STUDI
                </div>
                <div style={{ fontWeight: 700, fontSize: 11 }}>
                  {f.istituto}
                </div>
                <div style={{ fontSize: 10, color: "#6b7280" }}>
                  {f.titolo}
                  <br />
                  {f.anno}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     35. NEWSPAPER
  ═══════════════════════════════════════════ */
  if (tpl.style === "newspaper") {
    return (
      <CVBase style={{ fontFamily: "Georgia, serif", background: "#fff" }}>
        <div
          style={{ borderBottom: "3px double #111", padding: "12px 32px 8px" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              borderBottom: "1px solid #111",
              paddingBottom: 8,
              marginBottom: 8,
            }}
          >
            <Avatar
              size={48}
              radius="50%"
              border="2px solid #111"
              bg="#333"
              textColor="#fff"
            />
            <div style={{ textAlign: "center", flex: 1 }}>
              <div style={{ fontSize: 30, fontWeight: 700, letterSpacing: -1 }}>
                {I.nome} {I.cognome}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 16,
              fontSize: 10,
              color: "#555",
              fontFamily: "sans-serif",
              letterSpacing: 2,
            }}
          >
            <span>{I.ruolo.toUpperCase()}</span>
            <span>·</span>
            <span>{I.email}</span>
            <span>·</span>
            <span>{I.citta}</span>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 0,
            padding: "12px 20px",
          }}
        >
          <div
            style={{
              gridColumn: "1/3",
              paddingRight: 16,
              borderRight: "1px solid #ddd",
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontFamily: "sans-serif",
                fontWeight: 700,
                letterSpacing: 3,
                color: "#555",
                marginBottom: 10,
                borderBottom: "1px solid #ddd",
                paddingBottom: 4,
              }}
            >
              ESPERIENZE
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 14,
                  paddingBottom: 12,
                  borderBottom: "1px solid #f5f5f5",
                }}
              >
                <div style={{ fontWeight: 700, fontSize: 14 }}>{e.ruolo}</div>
                <div
                  style={{
                    fontSize: 11,
                    fontFamily: "sans-serif",
                    color: "#555",
                    marginBottom: 4,
                  }}
                >
                  {e.azienda} — {e.periodo}
                </div>
                <div style={{ fontSize: 12, lineHeight: 1.6 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
          </div>
          <div style={{ paddingLeft: 16 }}>
            <div
              style={{
                fontSize: 11,
                fontFamily: "sans-serif",
                fontWeight: 700,
                letterSpacing: 3,
                color: "#555",
                marginBottom: 10,
                borderBottom: "1px solid #ddd",
                paddingBottom: 4,
              }}
            >
              SKILLS
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 12,
                  padding: "4px 0",
                  borderBottom: "1px solid #f5f5f5",
                }}
              >
                {s}
              </div>
            ))}
            <div
              style={{
                fontSize: 11,
                fontFamily: "sans-serif",
                fontWeight: 700,
                letterSpacing: 3,
                color: "#555",
                marginTop: 14,
                marginBottom: 8,
                borderBottom: "1px solid #ddd",
                paddingBottom: 4,
              }}
            >
              STUDI
            </div>
            {F.map((f, i) => (
              <div key={i}>
                <div style={{ fontWeight: 700, fontSize: 12 }}>
                  {f.istituto}
                </div>
                <div
                  style={{
                    fontSize: 11,
                    fontFamily: "sans-serif",
                    color: "#555",
                  }}
                >
                  {f.anno}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     36. CREATIVE MIX
  ═══════════════════════════════════════════ */
  if (tpl.style === "creative_mix") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div style={{ display: "flex", height: "100%" }}>
          <div
            style={{
              width: "42%",
              background: "#f43f5e",
              display: "flex",
              flexDirection: "column",
              padding: 24,
            }}
          >
            <Avatar
              size={60}
              radius="50%"
              border="2px solid rgba(255,255,255,0.6)"
              bg="rgba(0,0,0,0.2)"
              textColor="#fff"
              style={{ marginBottom: 14 }}
            />
            <div
              style={{
                fontSize: 26,
                fontWeight: 900,
                color: "#fff",
                lineHeight: 0.9,
                letterSpacing: -1,
                marginBottom: 6,
              }}
            >
              {I.nome}
              <br />
              {I.cognome}
            </div>
            <div
              style={{
                fontSize: 11,
                color: "rgba(255,255,255,0.8)",
                letterSpacing: 1,
                marginBottom: 16,
              }}
            >
              {I.ruolo}
            </div>
            <div
              style={{
                height: 2,
                background: "rgba(255,255,255,0.3)",
                marginBottom: 16,
              }}
            />
            <div style={{ flex: 1 }}>
              {SK.map((s, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 8,
                  }}
                >
                  <div
                    style={{
                      width: i % 3 === 0 ? 32 : i % 3 === 1 ? 24 : 40,
                      height: 4,
                      background: "rgba(255,255,255,0.9)",
                      borderRadius: 2,
                    }}
                  />
                  <span style={{ fontSize: 11, color: "#fff" }}>{s}</span>
                </div>
              ))}
            </div>
            <div
              style={{
                fontSize: 10,
                color: "rgba(255,255,255,0.6)",
                lineHeight: 1.8,
              }}
            >
              {I.email}
              <br />
              {I.telefono}
            </div>
          </div>
          <div style={{ flex: 1, padding: 24 }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#f43f5e",
                fontWeight: 700,
                marginBottom: 14,
              }}
            >
              ESPERIENZE
            </div>
            {E.map((e) => (
              <div
                key={e.id}
                style={{
                  marginBottom: 16,
                  position: "relative",
                  paddingLeft: 14,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 6,
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#f43f5e",
                  }}
                />
                <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                <div style={{ fontSize: 11, color: "#f43f5e" }}>
                  {e.azienda} · {e.periodo}
                </div>
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 3 }}>
                  {e.descrizione}
                </div>
              </div>
            ))}
            <div
              style={{
                fontSize: 10,
                letterSpacing: 3,
                color: "#f43f5e",
                fontWeight: 700,
                margin: "12px 0 10px",
              }}
            >
              FORMAZIONE
            </div>
            {F.map((f, i) => (
              <div
                key={i}
                style={{ background: "#fff1f2", borderRadius: 8, padding: 10 }}
              >
                <div style={{ fontWeight: 700, fontSize: 12 }}>{f.titolo}</div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>
                  {f.istituto} · {f.anno}
                </div>
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     37. SIMPLE
  ═══════════════════════════════════════════ */
  if (tpl.style === "simple") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            padding: "24px 36px 20px",
            background: "#f9fafb",
            borderBottom: "2px solid #e5e7eb",
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={56}
            radius="50%"
            border="2px solid #e5e7eb"
            bg="#374151"
            textColor="#fff"
          />
          <div>
            <div style={{ fontSize: 22, fontWeight: 700, color: "#111" }}>
              {I.nome} {I.cognome}
            </div>
            <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>
              {I.ruolo}
            </div>
            <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
              {I.email} · {I.telefono}
            </div>
          </div>
        </div>
        <div style={{ flex: 1, padding: "20px 36px" }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: "#374151",
              letterSpacing: 2,
              marginBottom: 12,
              borderBottom: "1px solid #e5e7eb",
              paddingBottom: 6,
            }}
          >
            ESPERIENZE
          </div>
          {E.map((e) => (
            <div key={e.id} style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
                <div style={{ fontSize: 11, color: "#9ca3af" }}>
                  {e.periodo}
                </div>
              </div>
              <div style={{ fontSize: 12, color: "#6b7280" }}>{e.azienda}</div>
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}>
                {e.descrizione}
              </div>
            </div>
          ))}
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: "#374151",
              letterSpacing: 2,
              margin: "16px 0 12px",
              borderBottom: "1px solid #e5e7eb",
              paddingBottom: 6,
            }}
          >
            FORMAZIONE
          </div>
          {F.map((f, i) => (
            <div key={i} style={{ marginBottom: 8 }}>
              <div style={{ fontWeight: 700 }}>{f.titolo}</div>
              <div style={{ fontSize: 12, color: "#6b7280" }}>
                {f.istituto} · {f.anno}
              </div>
            </div>
          ))}
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: "#374151",
              letterSpacing: 2,
              margin: "16px 0 12px",
              borderBottom: "1px solid #e5e7eb",
              paddingBottom: 6,
            }}
          >
            COMPETENZE
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {SK.map((s, i) => (
              <span
                key={i}
                style={{
                  fontSize: 11,
                  padding: "4px 10px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 6,
                  color: "#374151",
                }}
              >
                {s}
              </span>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     38. EXPERIENCE
  ═══════════════════════════════════════════ */
  if (tpl.style === "experience") {
    return (
      <CVBase style={{ flexDirection: "row", background: "#fff" }}>
        <div
          style={{
            width: 190,
            background: "#374151",
            color: "#fff",
            padding: 24,
          }}
        >
          <Avatar
            size={56}
            radius="50%"
            border="2px solid rgba(255,255,255,0.3)"
            bg="rgba(255,255,255,0.1)"
            textColor="#fff"
            style={{ marginBottom: 14 }}
          />
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>
            {I.nome}
            <br />
            {I.cognome}
          </div>
          <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 18 }}>
            {I.ruolo}
          </div>
          <div
            style={{
              fontSize: 9,
              letterSpacing: 2,
              color: "#6b7280",
              marginBottom: 8,
            }}
          >
            CONTATTI
          </div>
          <div style={{ fontSize: 10, color: "#d1d5db", lineHeight: 1.8 }}>
            {I.email}
            <br />
            {I.telefono}
          </div>
          <div
            style={{
              fontSize: 9,
              letterSpacing: 2,
              color: "#6b7280",
              marginTop: 16,
              marginBottom: 8,
            }}
          >
            SKILLS
          </div>
          {SK.map((s, i) => (
            <div
              key={i}
              style={{
                fontSize: 10,
                color: "#d1d5db",
                padding: "3px 0",
                borderBottom: "1px solid #4b5563",
              }}
            >
              {s}
            </div>
          ))}
        </div>
        <div style={{ flex: 1, padding: 24 }}>
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              color: "#374151",
              fontWeight: 700,
              marginBottom: 12,
            }}
          >
            ESPERIENZE LAVORATIVE
          </div>
          {E.map((e) => (
            <div
              key={e.id}
              style={{
                marginBottom: 16,
                paddingBottom: 14,
                borderBottom: "1px solid #f3f4f6",
              }}
            >
              <div style={{ fontWeight: 700 }}>{e.ruolo}</div>
              <div style={{ fontSize: 12, color: "#374151" }}>{e.azienda}</div>
              <div style={{ fontSize: 11, color: "#9ca3af" }}>{e.periodo}</div>
              <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
                {e.descrizione}
              </div>
            </div>
          ))}
          <div
            style={{
              fontSize: 10,
              letterSpacing: 2,
              color: "#374151",
              fontWeight: 700,
              marginBottom: 10,
            }}
          >
            FORMAZIONE
          </div>
          {F.map((f, i) => (
            <div key={i}>
              <div style={{ fontWeight: 700 }}>{f.titolo}</div>
              <div style={{ fontSize: 12, color: "#6b7280" }}>
                {f.istituto} · {f.anno}
              </div>
            </div>
          ))}
        </div>
      </CVBase>
    );
  }

  /* ═══════════════════════════════════════════
     39. SIMPLE TIMELINE
  ═══════════════════════════════════════════ */
  if (tpl.style === "simple_timeline") {
    return (
      <CVBase style={{ background: "#fff" }}>
        <div
          style={{
            padding: "20px 32px 16px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            gap: 16,
            alignItems: "center",
          }}
        >
          <Avatar
            size={52}
            radius="50%"
            border="2px solid #e5e7eb"
            bg="#6b7280"
            textColor="#fff"
          />
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <div>
              <div style={{ fontSize: 20, fontWeight: 700 }}>
                {I.nome} {I.cognome}
              </div>
              <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
                {I.ruolo}
              </div>
            </div>
            <div style={{ fontSize: 11, color: "#9ca3af", textAlign: "right" }}>
              {I.email}
              <br />
              {I.telefono}
            </div>
          </div>
        </div>
        <div style={{ flex: 1, display: "flex" }}>
          <div style={{ flex: 2, padding: "16px 28px" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: "#6b7280",
                fontWeight: 700,
                marginBottom: 14,
              }}
            >
              PERCORSO
            </div>
            {[
              ...E,
              ...F.map((f) => ({
                ...f,
                ruolo: f.titolo,
                azienda: f.istituto,
                periodo: f.anno,
                isEdu: true,
              })),
            ].map((item, i, arr) => (
              <div
                key={i}
                style={{ display: "flex", gap: 14, marginBottom: 0 }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      background: item.isEdu ? "#e5e7eb" : "#374151",
                      border: "2px solid #374151",
                      flexShrink: 0,
                    }}
                  />
                  {i < arr.length - 1 && (
                    <div
                      style={{
                        width: 1,
                        flex: 1,
                        background: "#e5e7eb",
                        minHeight: 16,
                      }}
                    />
                  )}
                </div>
                <div style={{ paddingBottom: 14 }}>
                  <div style={{ fontSize: 10, color: "#9ca3af" }}>
                    {item.periodo || item.anno}
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 12 }}>
                    {item.ruolo}
                  </div>
                  <div style={{ fontSize: 11, color: "#6b7280" }}>
                    {item.azienda}
                  </div>
                  {item.descrizione && (
                    <div
                      style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}
                    >
                      {item.descrizione}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div style={{ width: 160, padding: "16px 20px 16px 0" }}>
            <div
              style={{
                fontSize: 10,
                letterSpacing: 2,
                color: "#6b7280",
                fontWeight: 700,
                marginBottom: 12,
              }}
            >
              COMPETENZE
            </div>
            {SK.map((s, i) => (
              <div
                key={i}
                style={{
                  fontSize: 11,
                  padding: "5px 0",
                  borderBottom: "1px solid #f3f4f6",
                  color: "#374151",
                }}
              >
                {s}
              </div>
            ))}
          </div>
        </div>
      </CVBase>
    );
  }

  /* ── FALLBACK ── */
  return (
    <CVBase style={{ background: "#fff" }}>
      <div style={{ padding: 28 }}>
        <div
          style={{
            display: "flex",
            gap: 16,
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <Avatar
            size={56}
            radius="50%"
            border={`2px solid ${acc}`}
            bg={acc}
            textColor="#fff"
          />
          <div>
            <div style={{ fontSize: 22, fontWeight: 800 }}>
              {I.nome} {I.cognome}
            </div>
            <div style={{ color: acc }}>{I.ruolo}</div>
            <div style={{ fontSize: 11, opacity: 0.6 }}>
              {I.email} · {I.telefono}
            </div>
          </div>
        </div>
        {E.map((e) => (
          <div key={e.id} style={{ marginBottom: 12 }}>
            <strong>{e.ruolo}</strong> — {e.azienda}
            <div style={{ fontSize: 12, opacity: 0.6 }}>{e.periodo}</div>
            <div>{e.descrizione}</div>
          </div>
        ))}
        <div
          style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 12 }}
        >
          {SK.map((s, i) => (
            <span
              key={i}
              style={{
                fontSize: 11,
                padding: "4px 8px",
                border: `1px solid ${acc}`,
                borderRadius: 6,
              }}
            >
              {s}
            </span>
          ))}
        </div>
      </div>
    </CVBase>
  );
};
